module.exports = {
	"AccountAdd.btn.add": "Добавить аккаунт",
	"AccountAdd.error.create": "Ошибка создания аккаунта. {errors}",
	"AccountAdd.error.message.create": "Ошибка создания аккаунта: {errors}.",
	"AccountAdd.error.server": "Ошибка сервера. Попробуйте позже.",
	"AccountAdd.success.created": "Аккаунт создан",
	"AccountAdd.success.message.created": "Аккаунт успешно создан.",
	"AccountAdd.validation.email.this_value_is_not_a_valid_email_address": "Введите валидный Email.",
	"AccountAdd.validation.email.this_value_should_not_be_blank": "Email не может быть пустым.",
	"AccountAdd.validation.password.this_value_should_not_be_blank": "Пароль не может быть пустым.",
	"AccountAdd.validation.username.this_value_should_not_be_blank": "Название не может быть пустым.",
	"AccountEditing.2FA.notEnabled": "Для аккаунта 2FA не была включена",
	"AccountEditing.2FA.resetSuccess": "Двухфакторная аутентификация сброшена",
	"AccountEditing.admin.error": "Ошибка при изменении статуса администратора",
	"AccountEditing.admin.granted": "Пользователь назначен администратором на проекте",
	"AccountEditing.admin.label": "Администратор на проекте",
	"AccountEditing.admin.revoked": "Администраторские права сняты",
	"AccountEditing.admin.save": "Сохранить",
	"AccountEditing.admin.saving": "Сохранение...",
	"AccountEditing.btn.reset2FA": "Сбросить 2FA",
	"AccountEditing.btn.save": "Сохранить",
	"AccountEditing.btn.saving": "Сохранение...",
	"AccountEditing.btn.sendNewPassword": "Выслать новый пароль",
	"AccountEditing.empty": "Аккаунт не выбран",
	"AccountEditing.error.reset2FA": "Ошибка при сбросе 2FA",
	"AccountEditing.error.save": "Ошибка при сохранении аккаунта",
	"AccountEditing.error.sendPassword": "Ошибка при отправке нового пароля",
	"AccountEditing.global.configure": "Настроить права",
	"AccountEditing.global.enable": "Включить глобальные права",
	"AccountEditing.global.hint": "Применяются ко всем проектам пользователя",
	"AccountEditing.global.modalTitle": "Глобальные права пользователя",
	"AccountEditing.global.readOnlyMessage": "Используются глобальные права. Для изменения перейдите в раздел «Глобальные права».",
	"AccountEditing.global.title": "Глобальные права",
	"AccountEditing.label.createdAt": "Дата создания",
	"AccountEditing.label.id": "ID",
	"AccountEditing.label.lastLoginAt": "Дата последней авторизации",
	"AccountEditing.label.neverLoggedIn": "Не авторизовывался",
	"AccountEditing.label.updatedAt": "Дата последних изменений",
	"AccountEditing.loading.data": "Загрузка...",
	"AccountEditing.loading.saving": "Сохранение...",
	"AccountEditing.modal.permissions": "Права на проекте {project}",
	"AccountEditing.modal.permissionsGlobal": "Права на проекте {project} (глобальные)",
	"AccountEditing.status.active": "Активен",
	"AccountEditing.status.blocked": "Заблокирован",
	"AccountEditing.status.closed": "Закрыт",
	"AccountEditing.status.inactive": "Не активен",
	"AccountEditing.status.passwordConfirm": "Пароль учетной записи «{account}» был изменен. Сохранить изменения?",
	"AccountEditing.success.passwordSent": "Новый пароль отправлен на email пользователя",
	"AccountEditing.success.saved": "Изменения аккаунта сохранены",
	"AccountEditing.title.account": "Аккаунт",
	"AccountEditing.title.contacts": "Контактные",
	"AccountEditing.title.merchants": "Мерчанты",
	"AccountSearchList.empty": "Нет привязанных аккаунтов",
	"AccountSearchList.label.email": "Email",
	"AccountSearchList.label.id": "Идентификатор",
	"AccountSearchList.label.name": "Имя",
	"AccountSearchList.noResults": "Ничего не найдено",
	"AccountSearchList.search.placeholder": "Поиск по ID, ФИО, email...",
	"Accounts.button.add": "Добавить",
	"Accounts.modal.addTitle": "Добавить учетную запись",
	"Accounts.title.accountsList": "Учетные записи",
	"Accounts.title.terminalsList": "Терминалы",
	"AccountsFilters.btn.filter": "Фильтровать",
	"AccountsFilters.status.active": "Активен",
	"AccountsFilters.status.blocked": "Заблокирован",
	"AccountsFilters.status.closed": "Закрыт",
	"AccountsFilters.status.inactive": "Не активен",
	"AccountsFilters.title.status": "Статус",
	"AccountsList.empty": "Учетных записей не найдено",
	"AccountsList.status.active": "Активен",
	"AccountsList.status.blocked": "Заблокирован",
	"AccountsList.status.closed": "Закрыт",
	"AccountsList.status.inactive": "Не активен",
	"AccountsList.table.createdAt": "Дата создания",
	"AccountsList.table.email": "Email",
	"AccountsList.table.id": "ID",
	"AccountsList.table.status": "Статус",
	"AccountsList.table.user": "Пользователь",
	"AdminFiltersToggle.label": "Фильтры",
	"AdministrationMenu.list.analytics": "Аналитика",
	"AdministrationMenu.list.finance": "Финансы",
	"AdministrationMenu.list.payments": "Платежи",
	"AdministrationMenu.list.registries": "Реестры",
	"AdministrationMenu.list.reports": "Отчеты",
	"AdministrationMenu.list.settings": "Настройки",
	"AdministrationMenu.list.stats": "Статистика",
	"AdministrationMenu.list.support": "Поддержка",
	"AdministrationMenu.title.accounts": "Настройки",
	"AdministrationMenu.title.accountsList": "Учетные записи",
	"AdministrationMenu.title.adminAudit": "Журнал действий",
	"AdministrationMenu.title.antifraud": "Антифрод",
	"AdministrationMenu.title.payoutHolds": "Остановленные выплаты",
	"AdministrationMenu.title.console": "Админ-панель",
	"AdministrationMenu.title.constructor": "Конструктор",
	"AdministrationMenu.title.crmPayoutRequests": "CRM-заявки",
	"AdministrationMenu.title.crmSbpPayoutRequests": "CRM-заявки СБП",
	"AdministrationMenu.title.deposits": "Депозиты",
	"AdministrationMenu.title.disputes": "Диспуты",
	"AdministrationMenu.title.frod": "Анти-фрод",
	"AdministrationMenu.title.payments": "Платежи",
	"AdministrationMenu.title.projectsList": "Проекты",
	"AdministrationMenu.title.reconciliation": "Сверка",
	"AdministrationMenu.title.registries": "Реестры",
	"AdministrationMenu.title.secretChats": "Секретные чаты",
	"AdministrationMenu.title.settlements": "Расчёты",
	"AdministrationMenu.title.terminalsList": "Терминалы",
	"AdministrationMenu.title.tickets": "Обращения",
	"AdministrationMenu.title.trafficMonitoring": "Мониторинг трафика",
	"AdministrationMenu.title.transactionAudit": "Аудит транзакций",
	"AntiFraud.add": "Добавить",
	"AntiFraud.details.delete": "Удалить",
	"AntiFraud.details.title": "Детали записи",
	"AntiFraud.details.unblock": "Разблокировать",
	"AntiFraud.filter.apply": "Применить",
	"AntiFraud.filter.kind": "Тип данных",
	"AntiFraud.filter.reset": "Сбросить",
	"AntiFraud.filter.source": "Источник",
	"AntiFraud.filter.status": "Статус",
	"AntiFraud.form.expiresAt": "Срок истечения (опционально)",
	"AntiFraud.form.kind": "Тип данных",
	"AntiFraud.form.reason": "Причина блокировки",
	"AntiFraud.form.source": "Источник",
	"AntiFraud.form.submit": "Добавить блокировку",
	"AntiFraud.form.value": "Значение",
	"AntiFraud.list.createdAt": "Создано",
	"AntiFraud.list.empty": "Нет записей",
	"AntiFraud.list.expiresAt": "Истекает",
	"AntiFraud.list.hits": "Попаданий",
	"AntiFraud.list.id": "ID",
	"AntiFraud.list.kind": "Тип",
	"AntiFraud.list.reason": "Причина",
	"AntiFraud.list.source": "Источник",
	"AntiFraud.list.status": "Статус",
	"AntiFraud.list.value": "Значение",
	"AntiFraud.modal.addTitle": "Добавить блокировку",
	"AntiFraud.search.mask": "Поиск по маске",
	"AntiFraud.search.maskPlaceholder": "Введите часть номера карты, IP или телефона...",
	"AntiFraud.stats.title": "Статистика",
	"AntiFraud.status.blocked": "Заблокирован",
	"AntiFraud.status.unblocked": "Разблокирован",
	"AntiFraud.title": "Антифрод записи",
	"AntiFraudDetails.delete": "Удалить",
	"AntiFraudDetails.title": "Детали записи",
	"AntiFraudDetails.unblock": "Разблокировать",
	"AntiFraudFilters.btn.filter": "Фильтровать",
	"AntiFraudFilters.btn.reset": "Сбросить",
	"AntiFraudFilters.status.blocked": "Заблокирован",
	"AntiFraudFilters.status.unblocked": "Разблокирован",
	"AntiFraudFilters.title.kind": "Тип данных",
	"AntiFraudFilters.title.source": "Источник",
	"AntiFraudFilters.title.status": "Статус",
	"AntiFraudForm.error.create": "Ошибка добавления записи",
	"AntiFraudForm.error.kindRequired": "Выберите тип данных",
	"AntiFraudForm.error.valueRequired": "Введите значение",
	"AntiFraudForm.expiresAt": "Срок действия (опционально)",
	"AntiFraudForm.expiresAt.hint": "Оставьте пустым для бессрочной блокировки",
	"AntiFraudForm.hint.card_pan": "Номер карты (16-19 цифр)",
	"AntiFraudForm.hint.inn": "ИНН (10 или 12 цифр)",
	"AntiFraudForm.hint.ip": "IP адрес",
	"AntiFraudForm.hint.name": "ФИО",
	"AntiFraudForm.hint.phone": "Номер телефона в формате 79001234567",
	"AntiFraudForm.hint.sbp_phone": "Телефон СБП в формате 79001234567",
	"AntiFraudForm.kind": "Тип данных",
	"AntiFraudForm.kind.placeholder": "-- Выберите тип --",
	"AntiFraudForm.placeholder.cardPan": "4111111111111111",
	"AntiFraudForm.placeholder.inn": "1234567890",
	"AntiFraudForm.placeholder.ip": "192.168.1.1",
	"AntiFraudForm.placeholder.phone": "79001234567",
	"AntiFraudForm.reason": "Причина блокировки",
	"AntiFraudForm.reason.default": "Ручная блокировка администратором",
	"AntiFraudForm.submit": "Добавить блокировку",
	"AntiFraudForm.value": "Значение",
	"AntiFraudForm.value.placeholder": "Введите значение",
	"AntiFraudList.empty": "Нет записей",
	"AntiFraudList.status.blocked": "Заблокирован",
	"AntiFraudList.status.unblocked": "Разблокирован",
	"AntiFraudList.table.hits": "Попадания",
	"AntiFraudList.table.id": "Идентификатор",
	"AntiFraudList.table.kind": "Тип",
	"AntiFraudList.table.lastSeen": "Последний раз",
	"AntiFraudList.table.reason": "Причина",
	"AntiFraudList.table.source": "Источник",
	"AntiFraudList.table.status": "Статус",
	"AntiFraudList.table.value": "Значение",
	"AuditLogsFilters.button.apply": "Применить",
	"AuditLogsFilters.button.reset": "Сбросить",
	"AuditLogsFilters.label.action": "Действие",
	"AuditLogsFilters.label.admin": "Администратор",
	"AuditLogsFilters.label.entityType": "Тип объекта",
	"AuditLogsFilters.label.periodFrom": "Период с",
	"AuditLogsFilters.label.periodTo": "по",
	"AuditLogsFilters.label.search": "Поиск",
	"AuditLogsFilters.option.all": "Все",
	"AuditLogsFilters.option.allActions": "Все действия",
	"AuditLogsFilters.option.allTypes": "Все типы",
	"AuditLogsFilters.placeholder.search": "По имени пользователя или объекту",
	"BalanceWidget.actualBalance": "Действительный баланс",
	"BalanceWidget.section.payin": "Приём платежей",
	"BalanceWidget.section.payout": "Выплаты",
	"BalanceWidget.settlementLabel.reimbursement": "Возмещение",
	"BalanceWidget.settlementLabel.reserve": "Резервный",
	"BalanceWidget.transactionBalance": "Транзакционный баланс",
	"Confirmation.btn.cabinet": "Перейти в кабинет",
	"Confirmation.btn.login": "Войти в кабинет",
	"Confirmation.btn.retry": "Попробовать ещё раз",
	"Confirmation.text.error": "Возможно, адрес уже подтверждён по этой ссылке или смену почты запросили заново. Проверьте почту в профиле и при необходимости запросите смену ещё раз.",
	"Confirmation.text.failed": "Проверьте подключение к интернету и попробуйте ещё раз. Если ошибка повторится, напишите в поддержку.",
	"Confirmation.text.success": "Новый адрес сохранён в профиле. Письма и уведомления теперь будут приходить на него.",
	"Confirmation.title.error": "Ссылка недействительна",
	"Confirmation.title.failed": "Не удалось подтвердить почту",
	"Confirmation.title.success": "Почта подтверждена",
	"Console.created": "Created",
	"Console.error": "Error",
	"Console.loading": "Загрузка…",
	"Console.pending": "Pending",
	"Console.title": "Админ-панель",
	"Console.transactionsTitle": "Транзакции требующие внимания",
	"ContractsTable.empty": "Нет контрактов",
	"ContractsTable.menu.edit": "Редактирование",
	"ContractsTable.menu.newPSA": "Новый ПСА для контракта",
	"ContractsTable.menu.psaList": "Список ПСА",
	"ContractsTable.table.date": "Дата",
	"ContractsTable.table.name": "Название",
	"ContractsTable.table.project": "Проект",
	"ContractsTable.table.psaCount": "Кол-во ПСА",
	"ContractsTable.table.psaProcessing": "ПСА в обработке",
	"CountryTop.table.country": "Страна",
	"CountryTop.table.declined": "Отклоненные",
	"CountryTop.table.successful": "Успешные",
	"CountryTop.table.transactions": "Транзакции",
	"CountryTop.table.turnover": "Оборот",
	"CrmPayout.action.bulkDecline": "Отклонить выбранные",
	"CrmPayout.action.decline": "Отклонить",
	"CrmPayout.action.formRegistry": "Сформировать реестр",
	"CrmPayout.action.retry": "Retry",
	"CrmPayout.action.selected": "Выбрано: {count}",
	"CrmPayout.detail.title": "Заявка",
	"CrmPayout.empty": "Заявки не найдены",
	"CrmPayout.filters.apply": "Применить",
	"CrmPayout.filters.payoutType": "Тип выплаты",
	"CrmPayout.filters.reset": "Сбросить",
	"CrmPayout.filters.status": "Статус",
	"CrmPayout.filters.title": "Фильтры",
	"CrmPayout.registry.download": "Скачать Excel",
	"CrmPayout.registry.title": "Реестр",
	"CrmPayout.registry.upload": "Загрузить отчёт",
	"CrmPayout.search.cardMask": "маска карты",
	"CrmPayout.search.cardMask.placeholder": "Введите маску карты (напр. 411111)",
	"CrmPayout.search.externalReference": "внешний ID",
	"CrmPayout.search.externalReference.placeholder": "Введите внешний ID",
	"CrmPayout.search.fullName": "ФИО",
	"CrmPayout.search.fullName.placeholder": "Введите ФИО получателя",
	"CrmPayout.search.merchantName": "мерчант",
	"CrmPayout.search.merchantName.placeholder": "Введите название мерчанта",
	"CrmPayout.search.phone": "телефон",
	"CrmPayout.search.phone.placeholder": "Введите номер телефона",
	"CrmPayout.search.transactionId": "ID транзакции",
	"CrmPayout.search.transactionId.placeholder": "Введите ID транзакции",
	"CrmPayout.stats.title": "Статистика",
	"CrmPayout.stats.total": "Всего",
	"CrmPayout.table.amount": "Сумма",
	"CrmPayout.table.card": "Карта/Телефон",
	"CrmPayout.table.date": "Дата",
	"CrmPayout.table.fullName": "ФИО",
	"CrmPayout.table.id": "Идентификатор",
	"CrmPayout.table.merchant": "Мерчант",
	"CrmPayout.table.status": "Статус",
	"CrmPayout.table.type": "Тип",
	"CrmPayout.title": "CRM-заявки на выплаты",
	"CrmSbpPayout.title": "CRM-заявки СБП",
	"CrmPayoutBoard.type.sbp": "СБП",
	"CrmPayoutDetails.action.cancel": "Отмена",
	"CrmPayoutDetails.action.confirm": "Подтвердить",
	"CrmPayoutDetails.action.confirmDecline": "Подтвердить отклонение",
	"CrmPayoutDetails.action.decline": "Отклонить",
	"CrmPayoutDetails.action.moveBack": "Вернуть в ожидание",
	"CrmPayoutDetails.action.moveToSuccess": "Перевести в успех",
	"CrmPayoutDetails.action.sendToAntifraud": "На антифрод",
	"CrmPayoutDetails.antifraud.toggle": "Антифрод",
	"CrmPayoutDetails.decline.placeholder": "Причина отклонения...",
	"CrmPayoutDetails.decline.title": "Причина отклонения",
	"CrmPayoutDetails.declineReasonRequired": "Укажите причину отклонения",
	"CrmPayoutDetails.error.generic": "Ошибка: {msg}",
	"CrmPayoutDetails.error.unknown": "Неизвестная ошибка",
	"CrmPayoutDetails.info.card": "Карта",
	"CrmPayoutDetails.info.createdAt": "Дата создания",
	"CrmPayoutDetails.info.description": "Описание",
	"CrmPayoutDetails.info.documentDate": "Дата документа",
	"CrmPayoutDetails.info.documentNumber": "Номер документа",
	"CrmPayoutDetails.info.email": "Email",
	"CrmPayoutDetails.info.fullName": "ФИО",
	"CrmPayoutDetails.info.merchant": "Мерчант",
	"CrmPayoutDetails.info.phone": "Телефон",
	"CrmPayoutDetails.info.registry": "Реестр",
	"CrmPayoutDetails.info.transaction": "Транзакция",
	"CrmPayoutDetails.info.updatedAt": "Обновлена",
	"CrmPayoutDetails.status.antifraud": "Антифрод",
	"CrmPayoutDetails.status.awaitingPayout": "Ожидает выплаты",
	"CrmPayoutDetails.status.created": "Создана",
	"CrmPayoutDetails.status.error": "Ошибка",
	"CrmPayoutDetails.status.registry": "В реестре",
	"CrmPayoutDetails.status.rejected": "Отклонена",
	"CrmPayoutDetails.status.success": "Успех",
	"CrmPayoutDetails.success.feePlaceholder": "Комиссия (необязательно)",
	"CrmPayoutDetails.success.movedToSuccess": "Заявка переведена в успех",
	"CrmPayoutDetails.success.sentToAntifraud": "Отправлено на антифрод",
	"CrmPayoutDetails.title": "Заявка #{id}",
	"CrmPayoutList.status.antifraud": "Антифрод",
	"CrmPayoutList.status.created": "Создана",
	"CrmPayoutList.status.error": "Ошибка",
	"CrmPayoutList.status.processing": "Обработка",
	"CrmPayoutList.status.registry": "В реестре",
	"CrmPayoutList.status.rejected": "Отклонена",
	"CrmPayoutList.status.success": "Успех",
	"Dashboard.help.payout": "Выплаты: {count}",
	"Dashboard.help.purchase": "Покупки: {count}",
	"Dashboard.help.recurrent": "Рекуррентные: {count}",
	"Dashboard.title.balance": "Баланс",
	"Dashboard.title.balanceOnDate": "Баланс на {date}",
	"Dashboard.title.errors": "Ошибки",
	"Dashboard.title.paymentSystems": "Платежные системы",
	"Dashboard.title.paymentsThisMonth": "Платежи за {month}",
	"Dashboard.title.paymentsToday": "Платежи за сегодня",
	"Dashboard.title.refills": "Пополнения",
	"Dashboard.title.statistics": "Статистика",
	"Dashboard.title.successful": "Успешных",
	"DateRange.days30": "30 дней",
	"DateRange.days7": "7 дней",
	"DateRange.from": "С:",
	"DateRange.halfYear": "полгода",
	"DateRange.month": "месяц",
	"DateRange.placeholder": "Выберите период",
	"DateRange.quickSelect": "Быстрый выбор",
	"DateRange.timeLabel": "Время:",
	"DateRange.title": "Период",
	"DateRange.to": "По:",
	"DateRange.today": "сегодня",
	"DateRange.week": "неделя",
	"DateRange.yesterday": "вчера",
	"DisputeDetails.action.archive": "В архив",
	"DisputeDetails.action.resolved": "Решено",
	"DisputeDetails.action.saveNote": "Сохранить примечание",
	"DisputeDetails.action.toWork": "В работу",
	"DisputeDetails.attachments.file": "Файл",
	"DisputeDetails.attachments.open": "Открыть",
	"DisputeDetails.attachments.photo": "Фото",
	"DisputeDetails.attachments.title": "Вложения ({count})",
	"DisputeDetails.error.check": "Ошибка проверки",
	"DisputeDetails.error.fileLoad": "Ошибка получения файла",
	"DisputeDetails.error.fileOpen": "Не удалось получить файл",
	"DisputeDetails.error.generic": "Ошибка: {message}",
	"DisputeDetails.error.saveNote": "Ошибка сохранения примечания",
	"DisputeDetails.error.unknown": "Неизвестная ошибка",
	"DisputeDetails.error.updateStatus": "Ошибка обновления статуса",
	"DisputeDetails.label.attachment": "Вложение:",
	"DisputeDetails.label.chat": "Чат:",
	"DisputeDetails.label.date": "Дата:",
	"DisputeDetails.label.sender": "Отправитель:",
	"DisputeDetails.linked.checkProvider": "Проверить у провайдера",
	"DisputeDetails.linked.currentStatus": "Текущий статус:",
	"DisputeDetails.linked.lastCheck": "Последняя проверка: {date}",
	"DisputeDetails.linked.merchant": "Мерчант:",
	"DisputeDetails.linked.providerResponse": "Ответ провайдера:",
	"DisputeDetails.linked.statusAtCreation": "Статус при создании:",
	"DisputeDetails.linked.transaction": "Привязанная транзакция:",
	"DisputeDetails.resolution.placeholder": "Примечание...",
	"DisputeDetails.resolution.resolvedBy": "Решено: {name} ({date})",
	"DisputeDetails.section.message": "Сообщение",
	"DisputeDetails.section.resolution": "Решение",
	"DisputeDetails.section.transaction": "Транзакция",
	"DisputeDetails.title": "Диспут",
	"DisputeDetails.transaction.amount": "Сумма:",
	"DisputeDetails.transaction.check": "Проверить",
	"DisputeDetails.transaction.merchant": "Мерчант:",
	"DisputeDetails.transaction.ourStatus": "Наш статус:",
	"DisputeDetails.transaction.placeholder": "ID транзакции",
	"DisputeDetails.transaction.provider": "Провайдер:",
	"DisputeDetails.transaction.providerStatus": "Статус провайдера:",
	"DisputeDetails.value.no": "Нет",
	"DisputeDetails.value.yes": "Да",
	"DisputeFilters.btn.filter": "Фильтровать",
	"DisputeFilters.btn.reset": "Сбросить",
	"DisputeFilters.title.status": "Статус",
	"Disputes.stats.title": "Статистика",
	"Disputes.title": "Диспуты",
	"DisputesList.attachment": "Вложение",
	"DisputesList.empty": "Диспуты не найдены",
	"DisputesList.table.chat": "Чат / Отправитель",
	"DisputesList.table.date": "Дата",
	"DisputesList.table.id": "Идентификатор",
	"DisputesList.table.merchant": "Мерчант",
	"DisputesList.table.message": "Сообщение",
	"DisputesList.table.status": "Статус",
	"DisputesList.table.transaction": "Транзакция",
	"Empty.message.dataSoon": "Данные скоро появятся",
	"EmptyChart.message": "Недостаточно данных для построения графика",
	"EventsWidget.btn.createTicket": "Оставить обращение",
	"EventsWidget.empty.message": "Здесь будут важные уведомления",
	"EventsWidget.title": "События",
	"FieldsHelper.error.charactersEmail": "Адрес электронной почты может содержать только буквы латинского алфавита, цифры и символы «_.@». Например: john_doe@email.ru",
	"FieldsHelper.error.checkAmount": "С суммой что-то не так. Проверьте и попробуйте еще раз. Например: 100.20",
	"FieldsHelper.error.checkBirthPlace": "С местом рождения что-то не так. Проверьте и попробуйте еще раз. Например: Г. ЛЫТКАРИНО",
	"FieldsHelper.error.checkCardNumber": "Вы указали номер неправильно. Проверьте его и попробуйте еще раз",
	"FieldsHelper.error.checkCardholderName": "С именем держателя карты что-то не так. Проверьте и попробуйте еще раз. Например: JOHN DOE",
	"FieldsHelper.error.checkEmail": "С адресом электронной почты что-то не так. Проверьте и попробуйте еще раз. Например: john_doe@email.ru",
	"FieldsHelper.error.checkIpSymbols": "С IP-адресом что-то не так. Проверьте и попробуйте еще раз. Например: 192.168.0.1",
	"FieldsHelper.error.checkIssued": "Вы указали данные неправильно. Проверьте поле и попробуйте еще раз",
	"FieldsHelper.error.checkLatinUsername": "С именем учетной записи что-то не так. Проверьте и попробуйте еще раз. Например: john777",
	"FieldsHelper.error.checkNumbersInn": "С ИНН что-то не так. Проверьте и попробуйте еще раз. Например: 773334101234",
	"FieldsHelper.error.checkOTPCode": "С одноразовым паролем что-то не так. Проверьте и попробуйте еще раз. Например: HS38ET",
	"FieldsHelper.error.checkPhone": "С номером телефона что-то не так. Проверьте и попробуйте еще раз. Например: +79854356633",
	"FieldsHelper.error.checkRegisterName": "С именем реестра что-то не так. Проверьте и попробуйте еще раз. Например: Выплаты за май",
	"FieldsHelper.error.checkUrlWebsite": "С адресом сайта что-то не так. Проверьте и попробуйте еще раз. Например: https://yandex.ru",
	"FieldsHelper.error.docIssuerCode": "Укажите код подразделения",
	"FieldsHelper.error.docNumber": "Укажите номер документа",
	"FieldsHelper.error.docSerial": "Укажите серию документа",
	"FieldsHelper.error.onlyCyrLatinRegisterName": "Название может состоять из букв латинского и кириллического алфавита, цифр и знаков «_().». Например: Выплаты за май",
	"FieldsHelper.error.onlyIpSymbols": "IP адрес может состоять только из цифр и разделяющих их точек. Например: 192.168.0.1",
	"FieldsHelper.error.onlyLatinBirthPlace": "Место рождения может содержать только латинские буквы и символы «.»",
	"FieldsHelper.error.onlyLatinCardholder": "Имя держателя карты может состоять только из букв латинского алфавита. Например: JOHN DOE",
	"FieldsHelper.error.onlyLatinIssued": "Может содержать только латинские буквы и символы «.\"». Например: ОУФМС РОССИИ ПО ГОР. Москве",
	"FieldsHelper.error.onlyLatinUsername": "Имя учетной записи может содержать только латинские буквы и цифры. Например: john777",
	"FieldsHelper.error.onlyLettersAddress": "Адрес рождения может содержать только латинские буквы, цифры и символы «.,/»",
	"FieldsHelper.error.onlyLettersFirstName": "Имя начинается с заглавной буквы и состоит из русского или латинского алфавита. Например: Игорь",
	"FieldsHelper.error.onlyLettersLastName": "Фамилия начинается с заглавной буквы и состоит из русского или латинского алфавита. Например: Курчатов",
	"FieldsHelper.error.onlyLettersMetalType": "Вид металла должен состоять только из букв",
	"FieldsHelper.error.onlyLettersNumbersOTPCode": "Одноразовый пароль может содержать только латинские буквы и цифры. Например: HS38ET",
	"FieldsHelper.error.onlyLettersPatronymic": "Отчество начинается с заглавной буквы и состоит из русского или латинского алфавита. Например: Васильевич",
	"FieldsHelper.error.onlyLettersProjectName": "Имя проекта может содержать только латинские буквы, цифры и символы «.\"». Например: Яндекс",
	"FieldsHelper.error.onlyNumbersAmount": "Сумма содержит только цифры и знак «.». Например: 100.20",
	"FieldsHelper.error.onlyNumbersInn": "ИНН может содержать только цифры. Например: 773334101234",
	"FieldsHelper.error.onlyNumbersMetalImpurity": "Засоренность может состоять только из цифр",
	"FieldsHelper.error.onlyNumbersMetalPrice": "Цена может состоять только из цифр",
	"FieldsHelper.error.onlyNumbersMetalWeight": "Вес может состоять только из цифр",
	"FieldsHelper.error.onlyNumbersPhone": "Телефон содержит только цифры и знак «+». Например: +79854356633.",
	"FieldsHelper.error.onlyUrlWebsite": "Адрес сайта может содержать только латинские буквы, цифры и символы «/.:». Например: https://yandex.ru",
	"FieldsHelper.label.ContractName": "Название контракта",
	"FieldsHelper.label.IPAccessRestriction": "Ограничение доступа по IP",
	"FieldsHelper.label.Issued": "Кем выдан",
	"FieldsHelper.label.PcaName": "Название ПСА",
	"FieldsHelper.label.PcaTypeMetal": "Вид металла",
	"FieldsHelper.label.amount": "Сумма",
	"FieldsHelper.label.authentication": "Двухфакторная аутентификация",
	"FieldsHelper.label.authenticationSelect": "Выберите тип",
	"FieldsHelper.label.birthCountry": "Страна рождения",
	"FieldsHelper.label.birthPlace": "Место рождения",
	"FieldsHelper.label.cardholder": "Держатель карты",
	"FieldsHelper.label.codeWord": "Кодовое слово",
	"FieldsHelper.label.contract": "Контракт",
	"FieldsHelper.label.contractBtn": "Создать",
	"FieldsHelper.label.contractBtnCreatePdf": "Скачать согласие на ОПД",
	"FieldsHelper.label.contractCreate": "Новый контракт",
	"FieldsHelper.label.contractDelete": "Удалить контракт",
	"FieldsHelper.label.contractEdit": "Редактирование контракта",
	"FieldsHelper.label.contractSave": "Сохранить",
	"FieldsHelper.label.contractsList": "Список всех контрактов",
	"FieldsHelper.label.departmentCode": "Код подразделения",
	"FieldsHelper.label.description": "Описание",
	"FieldsHelper.label.docNumber": "Номер документа",
	"FieldsHelper.label.docSerial": "Серия документа",
	"FieldsHelper.label.email": "Электронная почта",
	"FieldsHelper.label.firstName": "Имя",
	"FieldsHelper.label.gender": "Пол",
	"FieldsHelper.label.inn": "ИНН",
	"FieldsHelper.label.kpp": "КПП",
	"FieldsHelper.label.lastName": "Фамилия",
	"FieldsHelper.label.legalAddress": "Адрес регистрации",
	"FieldsHelper.label.legalName": "Название юрлица",
	"FieldsHelper.label.metalGrossWeight": "Вес брутто (тн)",
	"FieldsHelper.label.metalImpurity": "Засоренность (%)",
	"FieldsHelper.label.metalPrice": "Цена (руб)",
	"FieldsHelper.label.metalTareWeight": "Вес тары (тн)",
	"FieldsHelper.label.metalType": "Вид",
	"FieldsHelper.label.metalWeight": "Вес (тн)",
	"FieldsHelper.label.ogrn": "ОГРН",
	"FieldsHelper.label.otpCode": "Код",
	"FieldsHelper.label.password": "Пароль",
	"FieldsHelper.label.patronymic": "Отчество",
	"FieldsHelper.label.pca": "ПСА",
	"FieldsHelper.label.pcaBtn": "Сохранить и оплатить",
	"FieldsHelper.label.pcaBtnEdit": "Сохранить изменения",
	"FieldsHelper.label.pcaComment": "Комментарий для ПСА",
	"FieldsHelper.label.pcaCreate": "Новый ПСА",
	"FieldsHelper.label.pcaDelete": "Удаление ПСА",
	"FieldsHelper.label.pcaDescription": "Описание позиций",
	"FieldsHelper.label.pcaDescriptionMetal": "Описание лома и отходов",
	"FieldsHelper.label.pcaDownload": "Скачать в формате .xlsx",
	"FieldsHelper.label.pcaEdit": "ПСА",
	"FieldsHelper.label.pcaList": "Список всех ПСА",
	"FieldsHelper.label.pcaSourceMetal": "Источник лома",
	"FieldsHelper.label.pcaTransportMetal": "Марка и номер ТС",
	"FieldsHelper.label.phone": "Телефон",
	"FieldsHelper.label.processing": "Процессинг",
	"FieldsHelper.label.project": "Проект",
	"FieldsHelper.label.projectName": "Название",
	"FieldsHelper.label.projects": "Проекты",
	"FieldsHelper.label.registryName": "Название",
	"FieldsHelper.label.residenceAddress": "Адрес фактического проживания",
	"FieldsHelper.label.selectProcessing": "Выберите процессинг",
	"FieldsHelper.label.selectProject": "Выберите проект",
	"FieldsHelper.label.selectTerminal": "Выберите терминал",
	"FieldsHelper.label.terminal": "Терминал",
	"FieldsHelper.label.username": "Название",
	"FieldsHelper.label.websiteUrl": "Адрес сайта",
	"FieldsHelper.password.generate": "Сгенерировать пароль",
	"FieldsHelper.placeholder.birthCountry": "Выберите страну",
	"FieldsHelper.placeholder.gender": "Выберите пол",
	"HeaderMenu.list.account": "Мой профиль",
	"HeaderMenu.list.admin": "Админ панель",
	"HeaderMenu.list.adminPanel": "Админ-панель",
	"HeaderMenu.list.apiconsole": "Api консоль",
	"HeaderMenu.list.clientHome": "На главную",
	"HeaderMenu.list.closeMenu": "Закрыть меню",
	"HeaderMenu.list.logout": "Выход",
	"HeaderMenu.list.openMenu": "Открыть меню",
	"HeaderMenu.list.profile": "Профиль",
	"HeaderMenu.list.secretChats": "Чаты",
	"HeaderMenu.list.support": "Поддержка",
	"LanguageSelect.language.en": "English",
	"LanguageSelect.language.ru": "Русский",
	"LoginForm.btn.continue": "Продолжить",
	"LoginForm.btn.login": "Войти",
	"LoginForm.btn.sendAgain": "Выслать еще раз",
	"LoginForm.error.codeInvalid": "Код подтверждения неверный.",
	"LoginForm.error.codeRequired": "Код подтверждения обязателен.",
	"LoginForm.error.credentials": "E-mail или пароль неверны.",
	"LoginForm.error.blocked": "Учётная запись заблокирована. Обратитесь в поддержку.",
	"LoginForm.error.empty": "Поле E-mail и пароль обязательные.",
	"LoginForm.label.remember": "Запомнить меня",
	"LoginForm.link.cantLogin": "Не можете войти?",
	"LoginForm.link.forgotPassword": "Забыли пароль?",
	"LoginForm.logo.alt": "Логотип",
	"LoginForm.modal.cantLogin.alt.clearSiteData": "Очистка данных сайта",
	"LoginForm.modal.cantLogin.step.clearCache": "Очистите кеш страницы (Ctrl + F5)",
	"LoginForm.modal.cantLogin.step.clearSiteData": "Очистите данные сайта в браузере",
	"LoginForm.modal.cantLogin.step.contactSupport": "Обратитесь в поддержку:",
	"LoginForm.modal.cantLogin.title": "Не удаётся войти?",
	"LoginForm.modal.close": "Закрыть модальное окно",
	"LoginForm.modal.forgotPassword.btn.sendCode": "Отправить код",
	"LoginForm.modal.forgotPassword.btn.verifyCode": "Подтвердить код",
	"LoginForm.modal.forgotPassword.placeholder.code": "Код из письма",
	"LoginForm.modal.forgotPassword.placeholder.email": "Email",
	"LoginForm.modal.forgotPassword.title": "Сброс пароля",
	"LoginForm.placeholder.code": "Код",
	"LoginForm.placeholder.email": "Имя учетной записи",
	"LoginForm.placeholder.password": "Пароль",
	"LoginForm.recovery.error.codeRequired": "Введите код",
	"LoginForm.recovery.error.emailRequired": "Введите email",
	"LoginForm.recovery.error.invalidCode": "Неверный код",
	"LoginForm.recovery.error.sendCode": "Ошибка отправки кода",
	"LoginForm.recovery.error.verifyCode": "Ошибка проверки кода",
	"LoginForm.recovery.success.codeSent": "Если аккаунт существует, код отправлен на почту",
	"LoginForm.recovery.success.passwordSent": "Новый пароль отправлен на почту",
	"LoginForm.text.codeExpired": "Срок действия кода подтверждения истек.",
	"LoginForm.text.codeValid": "Код действителен еще {seconds} секунд",
	"LoginForm.text.mfaEmailMessage": "Введите код подтверждения из {type}-сообщения, отправленного на {email}",
	"LoginForm.text.mfaGAuthMessage": "Введите код подтверждения из приложения Google Authenticator",
	"LoginForm.text.mfaPhoneMessage": "Введите код подтверждения из {type}-сообщения, отправленного на номер {phone}",
	"LoginForm.title.login": "Вход в личный кабинет",
	"Merchant.select": "Выберите мерчант",
	"Merchant.title": "Мерчант",
	"MobileRegistry.table.amount": "Сумма",
	"MobileRegistry.table.bic": "БИК / ID банка",
	"MobileRegistry.table.cardHolderRu": "ФИО",
	"MobileRegistry.table.documentDate": "Дата док.",
	"MobileRegistry.table.documentNumber": "Номер док.",
	"MobileRegistry.table.phone": "Телефон",
	"MobileRegistry.upload.hint": "Перетащите реестр (телефон/СБП) в эту область или воспользуйтесь {link}",
	"Modal.cancel": "Отмена",
	"Modal.confirm": "Подтвердить",
	"Pay.error.checkBic": "Введите корректный БИК (7-9 цифр)",
	"Pay.error.checkBicOrMemberId": "Введите БИК (7-9 цифр) или ID банка СБП",
	"Pay.error.checkFio": "Введите ФИО получателя",
	"Pay.error.checkPhoneFormat": "Введите корректный номер телефона (10-15 цифр)",
	"Pay.error.documentDateFormat": "Введите дату в формате ГГГГ-ММ-ДД",
	"Pay.error.documentNumberRequired": "Введите номер ПСА",
	"Pay.error.onlyNumbersBic": "Только цифры",
	"Pay.label.amount": "Сумма платежа",
	"Pay.label.bankMemberId": "Банк получателя (СБП)",
	"Pay.label.bic": "БИК банка получателя",
	"Pay.label.bicOrMemberId": "БИК или ID банка (СБП)",
	"Pay.label.documentDate": "Дата ПСА",
	"Pay.label.documentNumber": "Номер ПСА",
	"Pay.label.finstarData": "Данные ПСА",
	"Pay.label.mobileRecipient": "Получатель (СБП)",
	"Pay.label.receiverCheck": "Получатель чека",
	"Pay.label.recipientFio": "ФИО (Фамилия Имя Отчество)",
	"Pay.label.recipientName": "ФИО получателя",
	"Pay.label.recipientPhone": "Номер телефона получателя",
	"Pay.label.transferRecipient": "Получатель перевода",
	"Pay.title.oneTimePayment": "Единовременный платеж",
	"Pay.toggle.card": "На карту",
	"Pay.toggle.mobile": "По телефону (СБП)",
	"PayControls.btn.send": "Отправить",
	"PayControls.label.amount": "Сумма:",
	"PayControls.label.balance": "Баланс:",
	"PayControls.label.card": "Перевод на карту:",
	"PayControls.label.commission": "Коммиссия:",
	"PayControls.label.email": "Email:",
	"PayControls.label.holder": "Держатель карты:",
	"PayControls.label.phone": "Телефон:",
	"PayControls.title": "Данные выплаты",
	"Payouts.title": "Проекты",
	"PayoutsDetail.btn.retryFailed": "Повторить неуспешные",
	"PayoutsDetail.modal.amount": "Сумма",
	"PayoutsDetail.modal.card": "Карта",
	"PayoutsDetail.modal.moreItems": "... и ещё {count}",
	"PayoutsDetail.modal.pendingListTitle": "Совпадающие транзакции в обработке:",
	"PayoutsDetail.modal.pendingWarning": "В обработке уже находятся карты из загруженного реестра. Возможно дублирование выплат.",
	"PayoutsDetail.modal.recipient": "Получатель",
	"PayoutsDetail.modal.warningTitle": "Внимание",
	"PayoutsDetailAmounts.label.failed": "Сумма невыплаченных:",
	"PayoutsDetailAmounts.label.other": "Сумма отложенных:",
	"PayoutsDetailAmounts.label.success": "Сумма выплаченных:",
	"PayoutsDetailEditing.btn.save": "Сохранить",
	"PayoutsDetailEditing.error.emptyName": "Название реестра не может быть пустым.",
	"PayoutsDetailEditing.error.generic": "Упс! Что-то пошло не так. Подождите некоторое время и попробуйте снова.",
	"PayoutsDetailEditing.error.network": "Упс! Что-то пошло не так. Обновите страницу и попробуйте снова.",
	"PayoutsDetailEditing.label.tags": "Метки",
	"PayoutsDetailEditing.placeholder.name": "Название не может быть пустым",
	"PayoutsDetailEditing.success.saved": "Успех! Данные сохранены.",
	"PayoutsDetailEditing.title": "Редактирование реестра",
	"PayoutsDetailFilters.btn.setFilters": "Фильтровать",
	"PayoutsDetailFilters.status.delayed": "Отложен",
	"PayoutsDetailFilters.status.error": "Ошибка",
	"PayoutsDetailFilters.status.filtered": "Отфильтрован",
	"PayoutsDetailFilters.status.paid": "Оплачен",
	"PayoutsDetailFilters.title.status": "Статус",
	"PayoutsDetailTags.noSuggestions": "Меток не найдено",
	"PayoutsDetailTags.placeholder": "Добавить метку",
	"PayoutsFilters.btn.filter": "Фильтровать",
	"PayoutsFilters.status.created": "Создан",
	"PayoutsFilters.status.delayed": "Отложен",
	"PayoutsFilters.status.inProgress": "Обрабатывается",
	"PayoutsFilters.status.processed": "Выполнен",
	"PayoutsFilters.status.processedWithErrors": "Выполнен с ошибками",
	"PayoutsFilters.title.status": "Статус",
	"PayoutsFilters.title.tags": "Метки",
	"PayoutsTable.empty": "Нет данных удовлетворяющих фильтрам",
	"PayoutsTable.status.created": "Отложен",
	"PayoutsTable.status.filtered": "Отфильтрован",
	"PayoutsTable.status.payout": "Оплачен",
	"PayoutsTable.status.payoutDecline": "Ошибка",
	"PayoutsTable.tab.bank": "Банк карты:",
	"PayoutsTable.tab.country": "Страна карты:",
	"PayoutsTable.tab.created": "Создан:",
	"PayoutsTable.tab.extStatus": "Расширенный статус:",
	"PayoutsTable.tab.fee": "Комиссия:",
	"PayoutsTable.tab.id": "ID операции:",
	"PayoutsTable.tab.params": "Параметры выплаты",
	"PayoutsTable.tab.processed": "Выполнен:",
	"PayoutsTable.tab.reason": "Причина ошибки:",
	"PayoutsTable.tab.system": "Платежная система:",
	"PayoutsTable.table.amount": "Сумма",
	"PayoutsTable.table.pan": "PAN",
	"PayoutsTable.table.phone": "Телефон",
	"PayoutsTable.table.recipient": "Получатель",
	"PayoutsTable.table.status": "Статус",
	"PcaFilters.status.error": "Ошибка / Платеж отклонен",
	"PcaFilters.status.inProgress": "Обрабатывается",
	"PcaFilters.status.inactive": "Не активен",
	"PcaFilters.status.processed": "Выплачен",
	"PcaFilters.title.status": "Статус",
	"PcaTable.empty": "Нет ПСА",
	"PcaTable.menu.duplicate": "Дублировать ПСА",
	"PcaTable.menu.view": "Просмотр ПСА",
	"PcaTable.status.declined": "Платеж отклонен",
	"PcaTable.status.error": "Ошибка",
	"PcaTable.status.inProgress": "Обрабатывается",
	"PcaTable.status.inactive": "Не активен",
	"PcaTable.status.paid": "Выплачено",
	"PcaTable.table.amount": "Сумма",
	"PcaTable.table.contract": "Контракт",
	"PcaTable.table.date": "Дата ПСА",
	"PcaTable.table.id": "ID",
	"PcaTable.table.name": "Название ПСА",
	"PcaTable.table.provider": "Провайдер",
	"PcaTable.table.status": "Статус",
	"PersonalManager.description": "По всем вопросам работы сервиса вы можете обращаться к вашему персональному менеджеру:",
	"PersonalManager.phone.mobile": "Мобильный",
	"PersonalManager.phone.work": "Рабочий",
	"PersonalManager.title": "Персональный менеджер",
	"Prepaid.title": "Предоплаченные карты",
	"Prepaid.title.activate": "Активация карты",
	"Prepaid.title.details": "Детализация карты",
	"PrepaidDetails.button.activate": "Активировать",
	"PrepaidDetails.gender.female": "Женский",
	"PrepaidDetails.gender.male": "Мужской",
	"PrepaidDetails.label.birthCountry": "Страна рождения:",
	"PrepaidDetails.label.birthPlace": "Место рождения:",
	"PrepaidDetails.label.birthday": "Дата рождения:",
	"PrepaidDetails.label.docIssuedDate": "Дата выдачи:",
	"PrepaidDetails.label.docIssuer": "Кем выдан:",
	"PrepaidDetails.label.docIssuerCode": "Код подразделения:",
	"PrepaidDetails.label.docNumber": "Номер документа:",
	"PrepaidDetails.label.docSerial": "Серия документа:",
	"PrepaidDetails.label.firstName": "Имя:",
	"PrepaidDetails.label.gender": "Пол:",
	"PrepaidDetails.label.lastName": "Фамилия:",
	"PrepaidDetails.label.legalAddress": "Адрес регистрации:",
	"PrepaidDetails.label.patronymic": "Отчество:",
	"PrepaidDetails.label.phone": "Телефон:",
	"PrepaidDetails.label.residenceAddress": "Адрес фактического проживания:",
	"PrepaidDetails.subtitle.ean": "EAN: {ean} ({part})",
	"PrepaidDetails.tab.contacts": "Контактная информация",
	"PrepaidDetails.tab.passport": "Паспортные данные",
	"PrepaidDetails.tab.personal": "Личные данные",
	"PrepaidTable.empty": "Нет предоплаченных карт",
	"PrepaidTable.menu.activate": "Активация",
	"PrepaidTable.menu.details": "Детализация",
	"PrepaidTable.status.active": "Активна",
	"PrepaidTable.status.error": "Ошибка",
	"PrepaidTable.status.inactive": "Не активна",
	"PrepaidTable.status.processing": "Обрабатывается",
	"PrepaidTable.table.card": "Карта",
	"PrepaidTable.table.client": "Клиент",
	"PrepaidTable.table.ean": "EAN",
	"PrepaidTable.table.project": "Проект",
	"PrepaidTable.table.status": "Статус",
	"Profile.btn.activate": "Активировать",
	"Profile.btn.connectOTP": "Подключить",
	"Profile.btn.save": "Сохранить изменения",
	"Profile.button.changePassword": "Изменить пароль",
	"Profile.button.save": "Сохранить изменения",
	"Profile.error.emailConfirmationNotSent": "Не удалось отправить письмо на {email}. Почта пока прежняя — попробуйте сменить её позже или напишите в поддержку.",
	"Profile.error.save": "Ошибка. В форме присутствуют ошибки. Проверьте данные и попробуйте снова.",
	"Profile.label.email": "Email",
	"Profile.label.firstName": "Имя",
	"Profile.label.lastName": "Фамилия",
	"Profile.label.password": "Пароль",
	"Profile.label.patronymic": "Отчество",
	"Profile.link.cancel": "Отменить изменения",
	"Profile.modal.title": "Изменение данных",
	"Profile.section.password": "Смена пароля",
	"Profile.section.personal": "Личные данные",
	"Profile.success.emailConfirmationPending": "Мы отправили письмо на {email}. Адрес сменится после перехода по ссылке из письма.",
	"Profile.success.save": "Успех. Вы успешно сохранили форму.",
	"Profile.text.changeEmail": "Почтовый адрес учетной записи был изменен. После подтверждения на адрес {email} будет выслано письмо с дальнейшими инструкциями.",
	"Profile.text.changeIpAccessList": "Список разрешенных IP-адресов был изменен. После подтверждения личный кабинет будет доступен только с адресов: {ipAccessList}.",
	"Profile.text.changeIpAccessListClean": "Список разрешенных IP-адресов был изменен. После подтверждения личный кабинет будет доступен со всех адресов без ограничений.",
	"Profile.text.changeOTPEmail": "Для подтверждения операции необходимо ввести одноразовый пароль отправленный на email-адрес {email}. Если письмо отсутствует в папке \"Входящие\", проверьте папку \"Спам\".",
	"Profile.text.changeOTPGAuth": "Для подтверждения операции необходимо ввести одноразовый пароль сгенерированный в приложении Google Authenticator.",
	"Profile.text.changeOTPPhone": "Для подтверждения операции необходимо ввести одноразовый пароль отправленный в SMS-сообщении на номер {phone}.",
	"Profile.text.changePassword": "Пароль учетной записи был изменен. После подтверждения Вы будете разлогинены на всех устройствах. Перед подтверждением запишите и сохраните в надежном месте новый пароль: {password}",
	"Profile.text.logout": "После смены пароля произойдёт выход из аккаунта на всех устройствах.",
	"Profile.text.support": "Для смены ФИО обратитесь в техническую поддержку.",
	"Profile.title.myProfile": "Мой профиль",
	"Profile.warning.requires2FASetup": "Для продолжения работы необходимо настроить двухфакторную аутентификацию",
	"ProjectAdd.btn.add": "Добавить проект",
	"ProjectAdd.btn.saving": "Сохраняем...",
	"ProjectAdd.error.create": "Ошибка создания проекта. {errors}",
	"ProjectAdd.success.created": "Проект создан",
	"ProjectEditing.antifraud.title": "Антифрод",
	"ProjectEditing.button.deleteService": "Удалить сервис",
	"ProjectEditing.button.refresh": "Обновить из API",
	"ProjectEditing.button.reset": "Сбросить изменения",
	"ProjectEditing.button.save": "Сохранить",
	"ProjectEditing.empty": "Проект не выбран",
	"ProjectEditing.error.load": "Не удалось загрузить полные данные мерчанта",
	"ProjectEditing.error.refresh": "Не удалось обновить данные",
	"ProjectEditing.error.save": "Не удалось сохранить изменения",
	"ProjectEditing.fees.fixed": "Фикс",
	"ProjectEditing.fees.percent": "%",
	"ProjectEditing.fees.type": "Тип",
	"ProjectEditing.field.auth": "Данные авторизации",
	"ProjectEditing.field.description": "Описание",
	"ProjectEditing.field.fees": "Комиссии",
	"ProjectEditing.field.inn": "ИНН",
	"ProjectEditing.field.kpp": "КПП",
	"ProjectEditing.field.login": "Логин",
	"ProjectEditing.field.name": "Название",
	"ProjectEditing.field.ogrn": "ОГРН",
	"ProjectEditing.field.provider": "Провайдер",
	"ProjectEditing.field.secret": "Secret / API Key",
	"ProjectEditing.field.url": "Сайт",
	"ProjectEditing.loading": "Загрузка...",
	"ProjectEditing.merchantKey.hint": "Этот ключ мерчант использует для подписи/аутентификации запросов.",
	"ProjectEditing.merchantKey.title": "Ключ мерчанта",
	"ProjectEditing.mid.balance": "Баланс:",
	"ProjectEditing.mid.currency": "Валюта:",
	"ProjectEditing.mid.currencyBalance": "Валюта и баланс:",
	"ProjectEditing.mid.currentProvider": "Текущий провайдер:",
	"ProjectEditing.mid.delete": "Удалить",
	"ProjectEditing.mid.fee.add": "Добавить комиссию",
	"ProjectEditing.mid.fee.fixed": "Фикс.:",
	"ProjectEditing.mid.fee.minFixed": "Мин. фикс.:",
	"ProjectEditing.mid.fee.payment": "Платёж",
	"ProjectEditing.mid.fee.payout": "Выплата",
	"ProjectEditing.mid.fee.percent": "%:",
	"ProjectEditing.mid.fees": "Комиссии:",
	"ProjectEditing.mid.methods": "Доступные методы:",
	"ProjectEditing.mid.new": "новый",
	"ProjectEditing.mid.openTerminal": "Открыть настройки терминала",
	"ProjectEditing.mid.provider": "Провайдер:",
	"ProjectEditing.mid.terminalNotLinked": "Терминал не привязан",
	"ProjectEditing.mid.title": "МИД #{id}",
	"ProjectEditing.mid.widget": "Настройки виджета:",
	"ProjectEditing.modal.terminalSettings": "Настройки терминала",
	"ProjectEditing.modal.userPermissions": "Права пользователя {username}",
	"ProjectEditing.noData": "Нет данных",
	"ProjectEditing.section.services": "Сервисы (MID)",
	"ProjectEditing.settings.add": "+ Добавить настройку (MID)",
	"ProjectEditing.settings.empty": "Настройки не найдены",
	"ProjectEditing.settings.refresh": "Обновить из API",
	"ProjectEditing.settings.title": "Настройки мерчанта (MID)",
	"ProjectEditing.success.allSaved": "Все изменения сохранены",
	"ProjectEditing.title": "Проект",
	"ProjectEditing.users.title": "Пользователи проекта",
	"ProjectEditing.widget.callback": "Адрес колбека",
	"ProjectEditing.widget.callbackHint": "Адрес для отправки колбеков от виджета",
	"ProjectEditing.widget.generate": "Сгенерировать",
	"ProjectEditing.widget.key": "Ключ виджета",
	"ProjectEditing.widget.keyHint": "Ключ для авторизации виджета",
	"ProjectSearchList.empty": "Ничего не найдено",
	"ProjectSearchList.permissions.btn": "Права",
	"ProjectSearchList.permissions.title": "Настроить права",
	"ProjectSearchList.placeholder": "Поиск проекта по названию или UUID...",
	"ProjectSearchList.remove.aria": "Удалить {name}",
	"ProjectSearchList.selected.title": "Выбранные проекты",
	"ProjectSettings.button.save": "Сохранить",
	"ProjectSettings.checkbox.hideCardholder": "Не показывать поле \"Имя и фамилия держателя карты\"",
	"ProjectSettings.checkbox.hideReceipt": "Не показывать поле \"Получить квитанцию\"",
	"ProjectSettings.checkbox.uniqueCheck": "Включить проверку уникальности значения",
	"ProjectSettings.general.description": "Описание проекта",
	"ProjectSettings.general.id": "ID проекта",
	"ProjectSettings.general.info.title": "Общая информация",
	"ProjectSettings.general.inn": "ИНН",
	"ProjectSettings.general.name": "Название проекта",
	"ProjectSettings.general.site": "Сайт",
	"ProjectSettings.general.technical": "Технические",
	"ProjectSettings.info.type": "Расчётная организация",
	"ProjectSettings.paymentForm.title": "Настройки платежной формы",
	"ProjectSettings.status.active": "Активен",
	"ProjectSettings.status.blocked": "Заблокирован",
	"ProjectSettings.tab.general": "Общие настройки",
	"ProjectSettings.tab.paymentForm": "Платежная форма",
	"ProjectSettings.tab.terminals": "Терминалы",
	"ProjectSettings.terminals.title": "Список терминалов",
	"Projects.button.add": "Добавить",
	"Projects.modal.addTitle": "Добавить новый проект",
	"ProjectsControl.title.projects": "Проекты",
	"ProjectsFilters.btn.filter": "Фильтровать",
	"ProjectsFilters.status.active": "Активен",
	"ProjectsFilters.status.blocked": "Заблокирован",
	"ProjectsFilters.status.inactive": "Не активен",
	"ProjectsFilters.title.status": "Статус",
	"ProjectsList.empty": "Учетных записей не найдено",
	"ProjectsList.table.accounts": "Учетные записи",
	"ProjectsList.table.createdAt": "Дата создания",
	"ProjectsList.table.name": "Название",
	"ProjectsList.table.status": "Статус",
	"ProjectsList.table.website": "Сайт",
	"ProjectsTable.link.payouts": "Выплаты",
	"ProjectsTable.link.settings": "Настройки",
	"ProjectsTable.status.active": "Активен",
	"ProjectsTable.status.blocked": "Заблокирован",
	"ProjectsTable.table.actualBalance": "Действительный",
	"ProjectsTable.table.balance": "Баланс",
	"ProjectsTable.table.project": "Проект",
	"ProjectsTable.table.reservedBalance": "Резервный",
	"ProjectsTable.table.settlementBalance": "Возмещение",
	"ProjectsTable.table.site": "Сайт",
	"ProjectsTable.table.status": "Статус",
	"ProjectsTable.table.transactionBalance": "Транзакционный",
	"ProjectsWidget.empty.title": "Нет активных проектов",
	"ProjectsWidget.error.load": "Не удалось загрузить проекты",
	"ProjectsWidget.help.avgBill": "Средний чек",
	"ProjectsWidget.link.viewAll": "Посмотреть все",
	"ProjectsWidget.table.balance": "Баланс",
	"ProjectsWidget.table.payments": "Платежи",
	"ProjectsWidget.table.payouts": "Выплаты",
	"ProjectsWidget.table.project": "Проект",
	"ProjectsWidget.table.settings": "Настройки",
	"ProjectsWidget.table.website": "Сайт",
	"ProjectsWidget.title": "Проекты",
	"RefillsFilters.btn.setFilters": "Применить фильтры",
	"RefillsFilters.status.crediting": "Пополнение",
	"RefillsFilters.status.writeOff": "Списание",
	"RefillsFilters.title.status": "Статус",
	"RefillsTable.empty": "Операций нет",
	"RefillsTable.table.amount": "Сумма",
	"RefillsTable.table.date": "Дата",
	"RefillsTable.table.project": "Проект",
	"RefillsTable.type.crediting": "Зачисление",
	"RefillsTable.type.writeOff": "Списание",
	"RegistryControls.btn.clear": "Очистить",
	"RegistryControls.checkbox.showErrors": "Показать ошибки",
	"RegistryControls.tags.label": "Добавить метки",
	"RegistryControls.tags.placeholder": "Добавить метки к реестру",
	"RegistryControls.title": "Управление реестром",
	"RegistryDADUpload.error.format": "(code: {code}) Ошибка! Реестр не соответствует формату. Устраните ошибки и повторите попытку.",
	"RegistryDADUpload.error.network": "Ошибка загрузки. Попробуйте снова.",
	"RegistryDADUpload.hint": "Перетащите реестр в эту область или нажмите для выбора",
	"RegistryDADUpload.link": "ссылкой",
	"RegistryDADUpload.loading": "Обработка...",
	"RegistryList.confirm.reprocess": "Обработать повторно реестр \"{name}\"?",
	"RegistryList.empty": "Реестров не найдено",
	"RegistryList.menu.downloadRegistry": "Выгрузить реестр",
	"RegistryList.menu.report": "Выгрузить отчет",
	"RegistryList.menu.reprocess": "Обработать повторно",
	"RegistryList.menu.view": "Детальный просмотр",
	"RegistryList.status.created": "Создан",
	"RegistryList.status.delayed": "Ожидание",
	"RegistryList.status.inProcessing": "Обрабатывается",
	"RegistryList.status.processed": "Выполнен",
	"RegistryList.status.processedWithErrors": "Выполнен с ошибками",
	"RegistryList.status.reprocess": "Повторная обработка",
	"RegistryList.table.amount": "Сумма",
	"RegistryList.table.date": "Дата",
	"RegistryList.table.fee": "Комиссия",
	"RegistryList.table.id": "ID",
	"RegistryList.table.merchant": "Мерчант",
	"RegistryList.table.status": "Статус",
	"RegistryList.table.tags": "Метки",
	"RegistryUpload.btn.sendRegistry": "Отправить реестр",
	"RegistryUpload.error.field": "Поле",
	"RegistryUpload.error.message": "Сообщение",
	"RegistryUpload.error.value": "Значение",
	"RegistryUpload.match.data": "Данные",
	"RegistryUpload.match.name": "Название",
	"RegistryUpload.modal.duplicateConfirm": "Вы уверены, что хотите продолжить?",
	"RegistryUpload.modal.duplicateTitle": "Обнаружен возможный дубликат",
	"RegistryUpload.modal.duplicateWarning": "При загрузке файла были обнаружены похожие реестры за последние 30 дней:",
	"RegistryUpload.table.amount": "Сумма",
	"RegistryUpload.table.cardHolderRu": "Имя держателя карты",
	"RegistryUpload.table.creditCard": "Номер карты",
	"RegistryUpload.table.phoneNumber": "Телефон",
	"RegistryUploadInfo.errors.format": "Ошибка формата файла",
	"RegistryUploadInfo.errors.missingColumn": "Необходимо добавить столбец: {column}",
	"RegistryUploadInfo.table.amount": "Сумма:",
	"RegistryUploadInfo.table.balance": "Баланс:",
	"RegistryUploadInfo.table.errors": "Ошибок:",
	"RegistryUploadInfo.table.fee": "Комиссия:",
	"RegistryUploadInfo.table.registry": "Реестр:",
	"ReportConstructor.btn.createReport": "Создать отчетов",
	"ReportConstructor.label.format": "Формат",
	"ReportConstructor.label.merchant": "Мерчант",
	"ReportConstructor.label.minFee": "Минимальная комиссия",
	"ReportConstructor.label.period": "Период",
	"ReportConstructor.label.providerFee": "Комиссия провайдера",
	"ReportConstructor.label.reportConstructor": "Конструктор отчетов",
	"ReportConstructor.label.reportType": "Тип отчёта",
	"ReportConstructor.label.selectMerchant": "Выберите мерчанта",
	"ReportConstructor.msg.error": "Ошибка при создании отчёта",
	"ReportConstructor.msg.noData": "Нет данных для отчёта",
	"ReportConstructor.msg.selectMerchant": "Выберите мерчанта",
	"ReportConstructor.msg.selectPeriod": "Выберите период",
	"ReportConstructor.option.merchants": "По мерчантам",
	"ReportConstructor.option.transactions": "По транзакциям",
	"ReportConstructor.table.amount": "Сумма пополнений",
	"ReportConstructor.table.count": "Кол-во операций",
	"ReportConstructor.table.fee": "Комиссия",
	"ReportConstructor.table.provider": "Провайдер",
	"ReportWidget.format": "Формат:",
	"ReportWidget.generate": "Сформировать отчет {format}",
	"ReportWidget.imageAlt": "Сформировать отчет",
	"ReportWidget.operations": "Операций",
	"SbpPay.label.recipient": "Получатель (СБП)",
	"SbpPay.title": "Выплата по СБП",
	"Search.example.amount": "например: 10 000",
	"Search.example.amountLess": "например: 10 000",
	"Search.example.cardHolder": "например: Ivan Ivanov",
	"Search.example.cardNumber": "например: 777777 •••• 7777",
	"Search.example.description": "например: Операция списания",
	"Search.example.email": "например: support@email.io",
	"Search.example.externalReference": "например: c8c32d92-cd65-428d-9e2f-896923a3b864",
	"Search.example.fio": "например: Иванов Иван",
	"Search.example.id": "например: 1288",
	"Search.example.pan": "например: 4111111111",
	"Search.example.phone": "74954453019",
	"Search.example.rrn": "___",
	"Search.label.accountId": "Номер учетной записи",
	"Search.label.amountEqually": "Сумма равна",
	"Search.label.amountLess": "Сумма меньше",
	"Search.label.amountMore": "Сумма больше",
	"Search.label.cardHolder": "Держатель карты",
	"Search.label.cardNumber": "Номер карты",
	"Search.label.currency": "Валюта",
	"Search.label.description": "Описание",
	"Search.label.email": "Электронной почте",
	"Search.label.externalReference": "Внешняя ссылка",
	"Search.label.fio": "Ф.И.О",
	"Search.label.merchantName": "имя мерчанта",
	"Search.label.messageText": "текст сообщения",
	"Search.label.operationId": "ID операции",
	"Search.label.pan": "PAN",
	"Search.label.phone": "Телефон",
	"Search.label.projectName": "название проекта",
	"Search.label.projectUuid": "UUID проекта",
	"Search.label.providerName": "Провайдер",
	"Search.label.registryData": "Искать по: ID, PAN, ФИО, сумме или телефону",
	"Search.label.rrn": "RRN",
	"Search.label.searchBy": "Искать по",
	"Search.label.senderName": "отправитель",
	"Search.label.terminalId": "ID терминала",
	"Search.label.terminalName": "Название терминала",
	"Search.label.transactionId": "ID транзакции",
	"Search.label.url": "адрес сайта",
	"Search.label.username": "Логин",
	"Search.label.uuid": "UUID проекта",
	"Search.placeholder.accountId": "Введите ID аккаунта",
	"Search.placeholder.currency": "Введите валюту (код)",
	"Search.placeholder.description": "Введите описание проекта",
	"Search.placeholder.email": "Введите email",
	"Search.placeholder.fio": "Введите ФИО",
	"Search.placeholder.merchantName": "Введите имя мерчанта",
	"Search.placeholder.messageText": "Введите текст для поиска",
	"Search.placeholder.projectName": "Введите название проекта",
	"Search.placeholder.projectUuid": "Введите UUID проекта",
	"Search.placeholder.providerName": "Введите имя провайдера",
	"Search.placeholder.senderName": "Введите имя отправителя",
	"Search.placeholder.terminalId": "Введите ID терминала",
	"Search.placeholder.terminalName": "Введите название терминала",
	"Search.placeholder.transactionId": "Введите ID транзакции",
	"Search.placeholder.url": "Введите адрес проекта",
	"Search.placeholder.username": "Логин",
	"Search.placeholder.uuid": "Введите UUID проекта",
	"SearchTags.add": "добавить",
	"SearchTags.find": "Найти",
	"SearchTags.label": "Поиск по",
	"SearchTags.placeholder.phone": "+7 (___) ___-__-__",
	"SearchTags.search": "Найти",
	"SecretChat.button.new": "Новый чат",
	"SecretChat.button.send": "Отправить",
	"SecretChat.day.today": "Сегодня",
	"SecretChat.empty.messages": "Пока пусто — напишите первым",
	"SecretChat.empty.pick": "Выберите чат или начните новый",
	"SecretChat.error.download": "Файл не скачался — возможно, он уже удалён",
	"SecretChat.error.load": "Не удалось загрузить переписку",
	"SecretChat.error.send": "Сообщение не отправлено",
	"SecretChat.file.attach": "Приложить файл",
	"SecretChat.file.download": "Скачать файл",
	"SecretChat.left.hours": "исчезнет через {hours} ч {minutes} мин",
	"SecretChat.left.minutes": "исчезнет через {minutes} мин",
	"SecretChat.list.title": "Разговоры",
	"SecretChat.loading": "Загрузка…",
	"SecretChat.note.ttl": "Переписка зашифрована и удаляется через {hours} ч",
	"SecretChat.placeholder": "Сообщение…",
	"SecretChats.admin.title": "Секретные чаты",
	"SecretChats.button.cancel": "Отмена",
	"SecretChats.button.clearClient": "Выбрать другого",
	"SecretChats.button.create": "Начать чат",
	"SecretChats.empty": "Чатов пока нет",
	"SecretChats.error.create": "Не удалось создать чат",
	"SecretChats.error.list": "Не удалось загрузить список чатов",
	"SecretChats.field.client": "Клиент: начните вводить имя или логин",
	"SecretChats.field.first": "Первое сообщение (необязательно)",
	"SecretChats.field.search": "Поиск клиента",
	"SecretChats.field.subject": "Тема разговора",
	"SecretChats.loading": "Загрузка…",
	"SecretChats.subtitle": "Переписка шифруется и полностью удаляется через {hours} часа",
	"SecretChats.title": "Секретные чаты",
	"Status.active": "Активен",
	"Status.blocked": "Заблокирован",
	"Status.inactive": "Неактивен",
	"Status.unknown": "Неизвестно",
	"Support.chat.button": "Чат поддержки",
	"Support.general.title": "Общие вопросы",
	"Support.manager.title": "Ваш менеджер",
	"Support.tech.title": "Технические вопросы",
	"Support.ticket.create": "Оставить обращение",
	"Support.ticket.title": "Нужна помощь?",
	"SupportWidget.action.attachFile": "Прикрепить файл",
	"SupportWidget.action.back": "Назад",
	"SupportWidget.action.collapse": "Свернуть",
	"SupportWidget.action.createTicket": "Создать обращение",
	"SupportWidget.action.send": "Отправить",
	"SupportWidget.action.sending": "Отправка...",
	"SupportWidget.attachment.purged": "файл удалён по сроку хранения",
	"SupportWidget.closedNote": "Обращение закрыто. Создайте новое, если нужна помощь.",
	"SupportWidget.edit.cancel": "Отмена",
	"SupportWidget.edit.save": "Сохранить",
	"SupportWidget.edit.title": "Редактировать",
	"SupportWidget.empty.chat": "Начните диалог — сообщения появятся здесь.",
	"SupportWidget.empty.listText": "Опишите проблему, прикрепите скриншоты или документы — мы ответим как можно быстрее.",
	"SupportWidget.empty.listTitle": "Задайте вопрос поддержке",
	"SupportWidget.error.bodyOrFileRequired": "Опишите ваш вопрос или прикрепите файл.",
	"SupportWidget.error.fileTooLarge": "Файл \"{name}\" больше 25 МБ.",
	"SupportWidget.error.maxFiles": "Не более 10 файлов на сообщение.",
	"SupportWidget.error.save": "Не удалось сохранить.",
	"SupportWidget.error.send": "Не удалось отправить.",
	"SupportWidget.error.subjectRequired": "Укажите тему обращения.",
	"SupportWidget.header.listSubtitle": "Мы обычно отвечаем в течение часа",
	"SupportWidget.header.listTitle": "Поддержка",
	"SupportWidget.header.newSubtitle": "Опишите ваш вопрос, мы поможем",
	"SupportWidget.header.newTitle": "Новое обращение",
	"SupportWidget.hint.attachments": "Можно прикрепить до 10 файлов (до 25 МБ каждый): скриншоты, документы, видео.",
	"SupportWidget.message.deleted": "сообщение удалено",
	"SupportWidget.message.edited": "изменено",
	"SupportWidget.placeholder.details": "Опишите ваш вопрос подробнее...",
	"SupportWidget.placeholder.message": "Сообщение...",
	"SupportWidget.placeholder.subject": "Тема обращения",
	"SupportWidget.size.bytes": "{count} б",
	"SupportWidget.size.kb": "{count} КБ",
	"SupportWidget.size.mb": "{count} МБ",
	"SupportWidget.status.closed": "Закрыто",
	"SupportWidget.status.open": "Открыто",
	"SupportWidget.status.pendingUser": "Ожидает ответа",
	"SupportWidget.time.daysAgo": "{count} д назад",
	"SupportWidget.time.hoursAgo": "{count} ч назад",
	"SupportWidget.time.justNow": "только что",
	"SupportWidget.time.minutesAgo": "{count} мин назад",
	"TerminalAdd.btn.create": "Создать",
	"TerminalAdd.error.create": "Не удалось создать терминал",
	"TerminalAdd.error.missing": "Укажите проект и название",
	"TerminalAdd.label.name": "Название",
	"TerminalAdd.label.project": "Проект",
	"TerminalAdd.label.provider": "Провайдер (опционально)",
	"TerminalAdd.label.status": "Статус",
	"TerminalAdd.placeholder.noProvider": "— не выбирать —",
	"TerminalAdd.placeholder.selectProject": "— выберите проект —",
	"TerminalAdd.status.active": "Активен",
	"TerminalAdd.status.inactive": "Неактивен",
	"TerminalAdd.success.created": "Терминал создан",
	"TerminalEditing.auth.empty": "Нет ключей авторизации",
	"TerminalEditing.button.save": "Сохранить",
	"TerminalEditing.button.saveLimits": "Сохранить лимиты",
	"TerminalEditing.empty": "Терминал не выбран",
	"TerminalEditing.error.loadLimits": "Ошибка загрузки лимитов",
	"TerminalEditing.error.save": "Не удалось сохранить терминал",
	"TerminalEditing.error.saveLimits": "Ошибка при сохранении лимитов",
	"TerminalEditing.field.balance": "Баланс",
	"TerminalEditing.field.bankAccount": "Bank account",
	"TerminalEditing.field.exchangeRate": "Exchange rate",
	"TerminalEditing.field.name": "Название",
	"TerminalEditing.field.paymentMethod": "Payment method",
	"TerminalEditing.field.returnUrl": "Адрес возврата",
	"TerminalEditing.field.status": "Статус",
	"TerminalEditing.field.webhookUrl": "Адрес колбека",
	"TerminalEditing.limits.amount": "Сумма",
	"TerminalEditing.limits.daily": "День",
	"TerminalEditing.limits.max": "Макс. сумма",
	"TerminalEditing.limits.min": "Мин. сумма",
	"TerminalEditing.limits.monthly": "Месяц",
	"TerminalEditing.limits.payment.title": "Платежи (payment)",
	"TerminalEditing.limits.payout.title": "Выплаты (payout)",
	"TerminalEditing.limits.payoutLimit.title": "Общий лимит выплат (payoutLimit)",
	"TerminalEditing.limits.perDay": "В день",
	"TerminalEditing.limits.perHour": "В час",
	"TerminalEditing.limits.perMinute": "В минуту",
	"TerminalEditing.limits.velocity.title": "Скорость (velocity)",
	"TerminalEditing.loading.limits": "Загрузка лимитов...",
	"TerminalEditing.method.h2h": "Человек к человеку",
	"TerminalEditing.method.partialRefund": "Частичный возврат",
	"TerminalEditing.method.partialReversal": "Частичная отмена",
	"TerminalEditing.method.preAuth": "Предавторизация",
	"TerminalEditing.method.recurring": "Рекуррент",
	"TerminalEditing.method.sbp": "СБП",
	"TerminalEditing.placeholder.notSet": "не установлено",
	"TerminalEditing.provider.current": "Текущий: {name}",
	"TerminalEditing.provider.noChange": "— не менять —",
	"TerminalEditing.save": "Сохранить",
	"TerminalEditing.saving.limits": "Сохранение...",
	"TerminalEditing.section.auth": "Данные авторизации (processingAuth)",
	"TerminalEditing.section.limits": "Лимиты",
	"TerminalEditing.section.methods": "Методы",
	"TerminalEditing.section.other": "Прочее",
	"TerminalEditing.section.provider": "Привязка провайдера",
	"TerminalEditing.status.active": "Активен",
	"TerminalEditing.status.inactive": "Неактивен",
	"TerminalEditing.success.limitsSaved": "Лимиты сохранены",
	"TerminalEditing.success.saved": "Терминал сохранён",
	"TerminalEditing.title": "Терминал",
	"Terminals.add": "Добавить",
	"Terminals.modal.addTitle": "Добавить терминал",
	"Terminals.title": "Терминалы",
	"TerminalsFilters.btn.apply": "Применить",
	"TerminalsFilters.method.partialRefund": "Частичный возврат",
	"TerminalsFilters.method.partialReversal": "Частичная отмена",
	"TerminalsFilters.method.preAuth": "Предавторизация",
	"TerminalsFilters.method.recurring": "Рекуррент",
	"TerminalsFilters.method.sbp": "СБП",
	"TerminalsFilters.provider.any": "— любой —",
	"TerminalsFilters.provider.label": "Провайдер",
	"TerminalsFilters.status.active": "Активные",
	"TerminalsFilters.status.inactive": "Неактивные",
	"TerminalsFilters.title": "Фильтры",
	"TerminalsList.currency": "Валюта: {name}",
	"TerminalsList.empty": "Ничего не найдено",
	"TerminalsList.method.p2p": "Р2Р",
	"TerminalsList.method.partialRefund": "Част. возврат",
	"TerminalsList.method.partialReversal": "Част. отмена",
	"TerminalsList.method.preAuth": "Предавт.",
	"TerminalsList.method.recurring": "Рекуррент",
	"TerminalsList.method.sbp": "СБП",
	"TerminalsList.status.active": "Активен",
	"TerminalsList.status.inactive": "Неактивен",
	"TerminalsList.table.balance": "Баланс",
	"TerminalsList.table.id": "Идентификатор",
	"TerminalsList.table.methods": "Методы",
	"TerminalsList.table.project": "Проект",
	"TerminalsList.table.provider": "Провайдер",
	"TerminalsList.table.status": "Статус",
	"TerminalsList.table.terminal": "Терминал",
	"TerminalsTable.empty": "Нет подключенных терминалов",
	"TerminalsTable.fee.fixed": "Комиссия за операцию:",
	"TerminalsTable.fee.fixedValue": "фикс. {value}",
	"TerminalsTable.fee.percent": "Комиссия за операцию:",
	"TerminalsTable.fee.percentValue": "{percent}% (минимум {min}р)",
	"TerminalsTable.status.active": "Активен",
	"TerminalsTable.status.blocked": "Заблокирован",
	"TerminalsTable.tab.payments": "Платежи",
	"TerminalsTable.tab.payouts": "Выплаты",
	"TerminalsTable.table.confirmed": "Баланс подтвержденный",
	"TerminalsTable.table.currency": "Валюта",
	"TerminalsTable.table.holded": "Баланс удержанный",
	"TerminalsTable.table.id": "ID",
	"TerminalsTable.table.mcc": "MCC",
	"TerminalsTable.table.name": "Название",
	"TerminalsTable.table.status": "Статус",
	"TerminalsTable.table.turnover": "Оборот",
	"TicketsTable.empty": "У вас нет тикетов",
	"TicketsTable.table.lastFrom": "Последнее сообщение от",
	"TicketsTable.table.message": "Сообщение",
	"TicketsTable.table.status": "Статус",
	"TicketsTable.table.updated": "Обновлён",
	"TransactionAudit.amount": "Сумма",
	"TransactionAudit.clearFilters": "Сбросить фильтры",
	"TransactionAudit.createdAt": "Создана",
	"TransactionAudit.direction": "Направление",
	"TransactionAudit.empty": "Нет данных аудита",
	"TransactionAudit.error": "Ошибка: {error}",
	"TransactionAudit.eventTypes": "Типы событий",
	"TransactionAudit.externalRef": "External Ref",
	"TransactionAudit.filters": "Фильтры",
	"TransactionAudit.fraud.blocked": "Заблокировано антифродом",
	"TransactionAudit.fraud.ok": "Антифрод: OK",
	"TransactionAudit.hint": "Введите ID транзакции для просмотра полной истории",
	"TransactionAudit.loading": "Загрузка данных...",
	"TransactionAudit.merchant": "Мерчант",
	"TransactionAudit.meta": "Детали",
	"TransactionAudit.noEvents": "События не записаны",
	"TransactionAudit.page.title": "Аудит транзакций",
	"TransactionAudit.payload": "Данные",
	"TransactionAudit.processingId": "Processing ID",
	"TransactionAudit.search": "Поиск",
	"TransactionAudit.searching": "Поиск...",
	"TransactionAudit.status": "Статус",
	"TransactionAudit.timeline": "История событий",
	"TransactionAudit.title": "Аудит транзакций",
	"TransactionAudit.transaction": "Транзакция",
	"TransactionsFilters.acquiring.card": "Банковские карты",
	"TransactionsFilters.acquiring.phone": "Мобильные телефоны",
	"TransactionsFilters.btn.setFilters": "Фильтровать",
	"TransactionsFilters.category.QR": "QR операции",
	"TransactionsFilters.category.SBP": "СБП операции",
	"TransactionsFilters.category.p2p": "P2P операции",
	"TransactionsFilters.category.payments": "Платежи",
	"TransactionsFilters.category.payout": "Выплаты",
	"TransactionsFilters.filters.registry": "Выплаты по реестрам",
	"TransactionsFilters.label.chargeback": "Chargeback",
	"TransactionsFilters.label.created": "Created",
	"TransactionsFilters.label.isDataLoading": "Получение данных...",
	"TransactionsFilters.label.mP2P": "Manual P2P",
	"TransactionsFilters.label.mP2PCreated": "Manual P2P Created",
	"TransactionsFilters.label.mP2PDecline": "Manual P2P Decline",
	"TransactionsFilters.label.mP2PPending": "Manual P2P Pending",
	"TransactionsFilters.label.mobilePayout": "Mobile Payout",
	"TransactionsFilters.label.mobilePayoutCreated": "Mobile Payout Created",
	"TransactionsFilters.label.mobilePayoutDecline": "Mobile Payout Decline",
	"TransactionsFilters.label.mobilePayoutPending": "Mobile Payout Pending",
	"TransactionsFilters.label.payout": "Payout",
	"TransactionsFilters.label.payoutCreated": "Payout created",
	"TransactionsFilters.label.payoutDecline": "Payout decline",
	"TransactionsFilters.label.payoutPending": "Payout pending",
	"TransactionsFilters.label.purchase": "Purchase",
	"TransactionsFilters.label.purchaseCreated": "Purchase created",
	"TransactionsFilters.label.purchaseDecline": "Purchase decline",
	"TransactionsFilters.label.purchasePending": "Purchase pending",
	"TransactionsFilters.label.qr": "QR Successful",
	"TransactionsFilters.label.qrCreated": "QR Created",
	"TransactionsFilters.label.qrDecline": "QR Decline",
	"TransactionsFilters.label.qrPending": "QR Pending",
	"TransactionsFilters.label.recurrent": "Recurrent",
	"TransactionsFilters.label.recurrentCreated": "Recurrent created",
	"TransactionsFilters.label.recurrentDecline": "Recurrent decline",
	"TransactionsFilters.label.recurrentPending": "Recurrent pending",
	"TransactionsFilters.label.refund": "Refund",
	"TransactionsFilters.label.refundCreated": "Refund created",
	"TransactionsFilters.label.refundDecline": "Refund decline",
	"TransactionsFilters.label.refundPending": "Refund pending",
	"TransactionsFilters.label.reversal": "Reversal",
	"TransactionsFilters.label.reversalCreated": "Reversal created",
	"TransactionsFilters.label.reversalDecline": "Reversal decline",
	"TransactionsFilters.label.reversalPending": "Reversal pending",
	"TransactionsFilters.label.sbp": "SBP",
	"TransactionsFilters.label.sbpCreated": "SBP Created",
	"TransactionsFilters.label.sbpDecline": "SBP Decline",
	"TransactionsFilters.label.sbpPending": "SBP Pending",
	"TransactionsFilters.label.successfulP2P": "Successful P2P",
	"TransactionsFilters.label.successfulSBP": "Successful SBP",
	"TransactionsFilters.label.successfulSbp": "Successful SBP",
	"TransactionsFilters.label.threeDSPending": "3DS Pending",
	"TransactionsFilters.title.acquiring": "Эквайринг",
	"TransactionsFilters.title.filters": "Фильтры",
	"TransactionsFilters.title.statuses": "Статусы",
	"TransactionsTable.amount.confirm": "Изменить сумму транзакции {id} на {amount}?",
	"TransactionsTable.amount.error.invalid": "Некорректный формат суммы. Пример: 1000 или 1000.50",
	"TransactionsTable.amount.error.required": "Введите сумму",
	"TransactionsTable.amount.error.save": "Не удалось изменить сумму транзакции",
	"TransactionsTable.amount.note": "Введите сумму в рублях, в БД сохраняется в копейках.",
	"TransactionsTable.amount.placeholder": "Например: 1000 или 1000.50",
	"TransactionsTable.amount.save": "Сохранить",
	"TransactionsTable.amount.saving": "Сохранение...",
	"TransactionsTable.amount.section": "Изменить сумму",
	"TransactionsTable.amount.success": "Сумма транзакции обновлена",
	"TransactionsTable.cancel.cancel": "Отмена ",
	"TransactionsTable.cancel.error": "Отмена платежа невозможна",
	"TransactionsTable.cancel.initiated": "По операции {id} инициирован {type}.",
	"TransactionsTable.cancel.loading": "Получение данных...",
	"TransactionsTable.cancel.refund": "Возврат ",
	"TransactionsTable.cancel.success": "Отмена инициирована",
	"TransactionsTable.check.amount": "Сумма:",
	"TransactionsTable.check.button": "Проверить транзакцию",
	"TransactionsTable.check.decline": "Перевести в Decline",
	"TransactionsTable.check.error": "Ошибка при проверке транзакции",
	"TransactionsTable.check.loading": "Проверка...",
	"TransactionsTable.check.message": "Сообщение:",
	"TransactionsTable.check.orderId": "Order ID:",
	"TransactionsTable.check.payout": "Перевести в Payout",
	"TransactionsTable.check.provider": "Провайдер:",
	"TransactionsTable.check.result": "Результат проверки:",
	"TransactionsTable.check.rrn": "RRN:",
	"TransactionsTable.check.status": "Статус:",
	"TransactionsTable.confirm.action": "Действие",
	"TransactionsTable.confirm.decline": "Перевести транзакцию {id} в статус Decline?",
	"TransactionsTable.confirm.payout": "Перевести транзакцию {id} в статус Payout?",
	"TransactionsTable.confirm.text": "Подтвердить операцию",
	"TransactionsTable.empty": "Платежей нет",
	"TransactionsTable.error.cancel": "Отмена платежа невозможна",
	"TransactionsTable.error.decline": "Не удалось перевести транзакцию в статус Decline",
	"TransactionsTable.error.payout": "Не удалось перевести транзакцию в статус Payout",
	"TransactionsTable.label.chargeback": "Chargeback",
	"TransactionsTable.label.created": "Created",
	"TransactionsTable.label.mP2P": "Manual P2P",
	"TransactionsTable.label.mP2PCreated": "Manual P2P Created",
	"TransactionsTable.label.mP2PDecline": "Manual P2P Decline",
	"TransactionsTable.label.mP2PPending": "Manual P2P Pending",
	"TransactionsTable.label.mobilePayout": "Mobile Payout",
	"TransactionsTable.label.mobilePayoutCreated": "Mobile Payout Created",
	"TransactionsTable.label.mobilePayoutDecline": "Mobile Payout Decline",
	"TransactionsTable.label.mobilePayoutPending": "Mobile Payout Pending",
	"TransactionsTable.label.payout": "Payout",
	"TransactionsTable.label.payoutCreated": "Payout created",
	"TransactionsTable.label.payoutDecline": "Payout decline",
	"TransactionsTable.label.payoutPending": "Payout pending",
	"TransactionsTable.label.purchase": "Purchase",
	"TransactionsTable.label.purchaseCreated": "Purchase created",
	"TransactionsTable.label.purchaseDecline": "Purchase decline",
	"TransactionsTable.label.purchasePending": "Purchase pending",
	"TransactionsTable.label.qr": "QR Successful",
	"TransactionsTable.label.qrCreated": "QR Created",
	"TransactionsTable.label.qrDecline": "QR Decline",
	"TransactionsTable.label.qrPending": "QR Pending",
	"TransactionsTable.label.recurrent": "Recurrent",
	"TransactionsTable.label.recurrentCreated": "Recurrent created",
	"TransactionsTable.label.recurrentDecline": "Recurrent decline",
	"TransactionsTable.label.recurrentPending": "Recurrent pending",
	"TransactionsTable.label.refund": "Refund",
	"TransactionsTable.label.refundCreated": "Refund created",
	"TransactionsTable.label.refundDecline": "Refund decline",
	"TransactionsTable.label.refundPending": "Refund pending",
	"TransactionsTable.label.reversal": "Reversal",
	"TransactionsTable.label.reversalCreated": "Reversal created",
	"TransactionsTable.label.reversalDecline": "Reversal decline",
	"TransactionsTable.label.reversalPending": "Reversal pending",
	"TransactionsTable.label.sbp": "SBP",
	"TransactionsTable.label.sbpCreated": "SBP Created",
	"TransactionsTable.label.sbpDecline": "SBP Decline",
	"TransactionsTable.label.sbpPending": "SBP Pending",
	"TransactionsTable.label.successfulP2P": "Successful P2P",
	"TransactionsTable.label.successfulSBP": "Successful SBP",
	"TransactionsTable.label.successfulSbp": "Successful SBP",
	"TransactionsTable.label.threeDSPending": "3DS Pending",
	"TransactionsTable.modal.refund": "Вернуть {amount}",
	"TransactionsTable.modal.reversal": "Отменить платеж {amount}",
	"TransactionsTable.modal.title": "Подтвердите действие",
	"TransactionsTable.refund.action": "Действие",
	"TransactionsTable.refund.button": "Возврат",
	"TransactionsTable.refund.id": "Идентификатор операции возврата",
	"TransactionsTable.refund.initiated": "Возврат инициирован",
	"TransactionsTable.refund.loading": "Получение данных...",
	"TransactionsTable.refund.status": "Статус",
	"TransactionsTable.refund.type": "Тип",
	"TransactionsTable.resend.button": "Отправить мерчанту повторно",
	"TransactionsTable.resend.buttonDeposit": "Повторить зачисление",
	"TransactionsTable.resend.confirm": "Отправить мерчанту уведомление по транзакции {id} повторно?",
	"TransactionsTable.resend.confirmDeposit": "Повторить доставку депозита {id} мерчанту?",
	"TransactionsTable.resend.confirmReopen": "Депозит {id} закрыт отказом мерчанта. Он будет отправлен мерчанту заново и, если мерчант его примет, зачислен на баланс мерчанта (сумма за вычетом комиссии). Продолжить?",
	"TransactionsTable.resend.error": "Не удалось отправить мерчанту повторно",
	"TransactionsTable.resend.flow.agent_deposit": "депозит агента",
	"TransactionsTable.resend.flow.craft_lite": "Paycraft (lite)",
	"TransactionsTable.resend.flow.fins_lite": "FinStar (lite)",
	"TransactionsTable.resend.flow.hydra_lite": "Hydracode (lite)",
	"TransactionsTable.resend.flow.npay_lite": "NPay (lite)",
	"TransactionsTable.resend.flow.queue": "штатное уведомление (очередь)",
	"TransactionsTable.resend.result.flow": "Формат: {flow}",
	"TransactionsTable.resend.result.host": "Адрес: {host}",
	"TransactionsTable.resend.result.httpCode": "Ответ мерчанта: HTTP {code}",
	"TransactionsTable.resend.sending": "Отправка...",
	"TransactionsTable.reversal.action": "Действие",
	"TransactionsTable.reversal.button": "Отменить платеж",
	"TransactionsTable.reversal.canceled": "Платеж отменён",
	"TransactionsTable.reversal.id": "Идентификатор операции отмены",
	"TransactionsTable.reversal.loading": "Получение данных...",
	"TransactionsTable.reversal.status": "Статус",
	"TransactionsTable.reversal.type": "Тип",
	"TransactionsTable.status.loading": "Ожидание ответа...",
	"TransactionsTable.status.waiting": "Статус",
	"TransactionsTable.success.cancel": "Отмена инициирована",
	"TransactionsTable.success.decline": "Статус транзакции обновлён на Decline",
	"TransactionsTable.success.payout": "Статус транзакции обновлён на Payout",
	"TransactionsTable.tab.action": "Действие:",
	"TransactionsTable.tab.actions": "Операции",
	"TransactionsTable.tab.amount": "Сумма:",
	"TransactionsTable.tab.audit": "Аудит",
	"TransactionsTable.tab.bank": "Банк карты:",
	"TransactionsTable.tab.cancelId": "ID",
	"TransactionsTable.tab.cancelType": "Тип операции",
	"TransactionsTable.tab.cardHolder": "Держатель карты:",
	"TransactionsTable.tab.confirm": "Подтверждение",
	"TransactionsTable.tab.country": "Страна карты:",
	"TransactionsTable.tab.email": "Электронная почта:",
	"TransactionsTable.tab.extStatus": "Расширенный статус:",
	"TransactionsTable.tab.extendedStatus": "Расширенный статус:",
	"TransactionsTable.tab.fee": "Коммиссия:",
	"TransactionsTable.tab.id": "Идентификатор операции:",
	"TransactionsTable.tab.management": "Управление",
	"TransactionsTable.tab.parameters": "Параметры платежа",
	"TransactionsTable.tab.params": "Параметры платежа",
	"TransactionsTable.tab.payment": "Данные платежа",
	"TransactionsTable.tab.paymentData": "Данные платежа",
	"TransactionsTable.tab.phone": "Телефон:",
	"TransactionsTable.tab.processId": "Идентификатор процесса:",
	"TransactionsTable.tab.processed": "Обработан:",
	"TransactionsTable.tab.refund": "Возврат средств",
	"TransactionsTable.tab.rrn": "RRN:",
	"TransactionsTable.tab.status": "Статус",
	"TransactionsTable.tab.waiting": "Ожидание ответа...",
	"TransactionsTable.table.amount": "Сумма",
	"TransactionsTable.table.date": "Дата",
	"TransactionsTable.table.payer": "Плательщик",
	"TransactionsTable.table.project": "Проект",
	"TransactionsTable.text.paymentPartialRefund": "По данной операции доступен частичный возврат. Максимальная сумма {amount}. Время возврата зависит от банка эмитента и составляет от 1 до 7 рабочих дней.",
	"TransactionsTable.text.paymentPartialReversal": "По данной операции доступна частичная отмена. Максимальная сумма {amount}. Время отмены зависит от банка эмитента и как правило происходит в течении часа.",
	"TransactionsTable.text.paymentRefund": "Будет осуществлен возврат на сумму {amount}. Время возврата зависит от банка эмитента и составляет от 1 до 7 рабочих дней.",
	"TransactionsTable.text.paymentReversal": "Будет осуществлена отмена платежа на сумму {amount}. Время отмены зависит от банка эмитента и как правило происходит в течении часа.",
	"UserMenu.list.home": "Главная",
	"UserMenu.list.projects": "Проекты",
	"UserMenu.list.transactions": "Операции",
	"UserMenu.title.antifraud": "Антифрод система",
	"UserMenu.title.antifraudFileCheck": "Проверка файла",
	"UserMenu.title.antifraudLog": "Лог проверок",
	"UserMenu.title.antifraudSingleCheck": "Разовая проверка",
	"UserMenu.title.finance": "Финансы",
	"UserMenu.title.metal": "Металл",
	"UserMenu.title.mobileRegistries": "Реестры (СБП)",
	"UserMenu.title.payments": "Платежи",
	"UserMenu.title.payouts": "Выплаты",
	"UserMenu.title.prepaid": "Активированные карты",
	"UserMenu.title.registries": "Реестры",
	"UserMenu.title.sbpPayouts": "Выплаты (СБП)",
	"UserMenu.title.sbpRegistries": "Реестры (СБП)",
	"UserMenu.title.statement": "Выписка",
	"UserSearchList.empty": "Ничего не найдено",
	"UserSearchList.loading": "Загрузка пользователей...",
	"UserSearchList.permissions.btn": "Права",
	"UserSearchList.permissions.title": "Настроить права",
	"UserSearchList.placeholder": "Поиск пользователя по ID, имени или email...",
	"UserSearchList.remove.aria": "Удалить {name}",
	"UserSearchList.selected.title": "Выбранные пользователи",
	"binBase.country.10": "Антарктика",
	"binBase.country.100": "Болгария",
	"binBase.country.104": "Мьянма",
	"binBase.country.108": "Бурунди",
	"binBase.country.112": "Беларусь",
	"binBase.country.116": "Камбоджа",
	"binBase.country.12": "Алжир",
	"binBase.country.120": "Камерун",
	"binBase.country.124": "Канада",
	"binBase.country.132": "Кабо-Верде",
	"binBase.country.136": "Каймановы о-ва (GB)",
	"binBase.country.140": "Центрально-африканская Республика",
	"binBase.country.144": "Шри-Ланка",
	"binBase.country.148": "Чад",
	"binBase.country.152": "Чили",
	"binBase.country.156": "Китай",
	"binBase.country.158": "Тайвань",
	"binBase.country.16": "Восточное Самоа (US)",
	"binBase.country.162": "Рождества о. (AU)",
	"binBase.country.166": "Кокосовые (Киилинг) о-ва (AU)",
	"binBase.country.170": "Колумбия",
	"binBase.country.174": "Коморские о-ва",
	"binBase.country.175": "Майотта о. (KM)",
	"binBase.country.178": "Конго",
	"binBase.country.180": "Демократическая Республика Конго",
	"binBase.country.184": "Кука о-ва (NZ)",
	"binBase.country.188": "Коста-Рика",
	"binBase.country.191": "Хорватия",
	"binBase.country.192": "Куба",
	"binBase.country.196": "Кипр",
	"binBase.country.20": "Андорра",
	"binBase.country.203": "Чехия",
	"binBase.country.204": "Бенин",
	"binBase.country.208": "Дания",
	"binBase.country.212": "Доминика",
	"binBase.country.214": "Доминиканская Республика",
	"binBase.country.218": "Эквадор",
	"binBase.country.222": "Сальвадор",
	"binBase.country.226": "Экваториальная Гвинея",
	"binBase.country.231": "Эфиопия",
	"binBase.country.232": "Эритрия",
	"binBase.country.233": "Эстония",
	"binBase.country.234": "Фарерские о-ва (DK)",
	"binBase.country.238": "Фолклендские (Мальвинские) о-ва (GB/AR)",
	"binBase.country.239": "Южная Георгия и Южные Сандвичевы о-ва",
	"binBase.country.24": "Ангола",
	"binBase.country.242": "Фиджи",
	"binBase.country.246": "Финляндия",
	"binBase.country.250": "Франция",
	"binBase.country.254": "Французская Гвиана (FR)",
	"binBase.country.258": "Французская Полинезия",
	"binBase.country.260": "Французские южные территории (FR)",
	"binBase.country.262": "Джибути",
	"binBase.country.266": "Габон",
	"binBase.country.268": "Грузия",
	"binBase.country.270": "Гамбия",
	"binBase.country.275": "Палестинская автономия",
	"binBase.country.276": "Германия",
	"binBase.country.28": "Антигуа и Барбуда",
	"binBase.country.280": "Германия",
	"binBase.country.288": "Гана",
	"binBase.country.292": "Гибралтар",
	"binBase.country.296": "Кирибати",
	"binBase.country.300": "Греция",
	"binBase.country.304": "Гренландия (DK)",
	"binBase.country.308": "Гренада",
	"binBase.country.31": "Азербайджан",
	"binBase.country.312": "Гваделупа",
	"binBase.country.316": "Гуам",
	"binBase.country.32": "Аргентина",
	"binBase.country.320": "Гватемала",
	"binBase.country.324": "Гвинея",
	"binBase.country.328": "Гайана",
	"binBase.country.332": "Гаити",
	"binBase.country.334": "Херд и Макдональд о-ва (AU)",
	"binBase.country.336": "Ватикан",
	"binBase.country.340": "Гондурас",
	"binBase.country.344": "Гонконг (CN",
	"binBase.country.348": "Венгрия",
	"binBase.country.352": "Исландия",
	"binBase.country.356": "Индия",
	"binBase.country.36": "Австралия",
	"binBase.country.360": "Индонезия",
	"binBase.country.364": "Иран",
	"binBase.country.368": "Ирак",
	"binBase.country.372": "Ирландия",
	"binBase.country.376": "Израиль",
	"binBase.country.380": "Италия",
	"binBase.country.384": "Кот-д'Ивуар",
	"binBase.country.388": "Ямайка",
	"binBase.country.392": "Япония",
	"binBase.country.398": "Казахстан",
	"binBase.country.4": "Афганистан",
	"binBase.country.40": "Австрия",
	"binBase.country.400": "Иордания",
	"binBase.country.404": "Кения",
	"binBase.country.408": "Северная Корея (КНДР)",
	"binBase.country.410": "Южная Корея (Республика Корея)",
	"binBase.country.414": "Кувейт",
	"binBase.country.417": "Киргизстан",
	"binBase.country.418": "Лаос",
	"binBase.country.422": "Ливан",
	"binBase.country.426": "Лесото",
	"binBase.country.428": "Латвия",
	"binBase.country.430": "Либерия",
	"binBase.country.434": "Ливия",
	"binBase.country.438": "Лихтенштейн",
	"binBase.country.44": "Багамы",
	"binBase.country.440": "Литва",
	"binBase.country.442": "Люксембург",
	"binBase.country.446": "Макао (PT)",
	"binBase.country.450": "Мадагаскар",
	"binBase.country.454": "Малави",
	"binBase.country.458": "Малайзия",
	"binBase.country.462": "Мальдивы",
	"binBase.country.466": "Мали",
	"binBase.country.470": "Мальта",
	"binBase.country.474": "Мартиника",
	"binBase.country.478": "Мавритания",
	"binBase.country.48": "Бахрейн",
	"binBase.country.480": "Маврикий",
	"binBase.country.484": "Мексика",
	"binBase.country.492": "Монако",
	"binBase.country.496": "Монголия",
	"binBase.country.498": "Молдова",
	"binBase.country.499": "Черногория",
	"binBase.country.50": "Бангладеш",
	"binBase.country.500": "Монсеррат о. (GB)",
	"binBase.country.504": "Марокко",
	"binBase.country.508": "Мозамбик",
	"binBase.country.51": "Армения",
	"binBase.country.512": "Оман",
	"binBase.country.516": "Намибия",
	"binBase.country.52": "Барбадос",
	"binBase.country.520": "Науру",
	"binBase.country.524": "Непал",
	"binBase.country.528": "Нидерланды",
	"binBase.country.530": "Антильские о-ва (NL)",
	"binBase.country.531": "Кюрасао",
	"binBase.country.533": "Аруба",
	"binBase.country.534": "Синт-Мартен",
	"binBase.country.535": "Бонэйр, Синт-Эстатиус и Саба",
	"binBase.country.540": "Новая Каледония о. (FR)",
	"binBase.country.548": "Вануату",
	"binBase.country.554": "Новая Зеландия",
	"binBase.country.558": "Никарагуа",
	"binBase.country.56": "Бельгия",
	"binBase.country.562": "Нигер",
	"binBase.country.566": "Нигерия",
	"binBase.country.570": "Ниуэ о. (NZ)",
	"binBase.country.574": "Норфолк о. (AU)",
	"binBase.country.578": "Норвегия",
	"binBase.country.580": "Северные Марианские",
	"binBase.country.581": "Соединенные Штаты Америки Внешние малые острова (US)",
	"binBase.country.583": "Микронезия (US)",
	"binBase.country.584": "Маршалловы о-ва",
	"binBase.country.585": "Палау (US)",
	"binBase.country.586": "Пакистан",
	"binBase.country.591": "Панама",
	"binBase.country.598": "Папуа-Новая Гвинея",
	"binBase.country.60": "Бермуды",
	"binBase.country.600": "Парагвай",
	"binBase.country.604": "Перу",
	"binBase.country.608": "Филиппины",
	"binBase.country.612": "Питкэрн о-ва (GB)",
	"binBase.country.616": "Польша",
	"binBase.country.620": "Португалия",
	"binBase.country.624": "Гвинея-Бисау",
	"binBase.country.626": "Восточный Тимор",
	"binBase.country.630": "Пуэрто-Рико (US)",
	"binBase.country.634": "Катар",
	"binBase.country.638": "Реюньон о. (FR)",
	"binBase.country.64": "Бутан",
	"binBase.country.642": "Румыния",
	"binBase.country.643": "Россия",
	"binBase.country.646": "Руанда",
	"binBase.country.654": "Святой Елены о. (GB)",
	"binBase.country.659": "Сент-Кристофер и Невис",
	"binBase.country.660": "Ангилья о. (GB)",
	"binBase.country.662": "Сент-Люсия",
	"binBase.country.666": "Сен-Пьер и Микелон (FR)",
	"binBase.country.670": "Сен-Винсент и Гренадины",
	"binBase.country.674": "Сан Марино",
	"binBase.country.678": "Сан-Томе и Принсипи",
	"binBase.country.68": "Боливия",
	"binBase.country.682": "Саудовская Аравия",
	"binBase.country.686": "Сенегал",
	"binBase.country.688": "Сербия",
	"binBase.country.690": "Сейшелы",
	"binBase.country.694": "Сьерра-Леоне",
	"binBase.country.70": "Босния и Герцеговина",
	"binBase.country.702": "Сингапур",
	"binBase.country.703": "Словакия",
	"binBase.country.704": "Вьетнам",
	"binBase.country.705": "Словения",
	"binBase.country.706": "Сомали",
	"binBase.country.710": "Южная Африка",
	"binBase.country.716": "Зимбабве",
	"binBase.country.72": "Ботсвана",
	"binBase.country.724": "Испания",
	"binBase.country.728": "Южный Судан",
	"binBase.country.729": "Судан",
	"binBase.country.732": "Западная Сахара",
	"binBase.country.736": "Судан",
	"binBase.country.74": "Бове о. (NO)",
	"binBase.country.740": "Суринам",
	"binBase.country.744": "Свалбард и Ян Мейен о-ва (NO)",
	"binBase.country.748": "Свазиленд",
	"binBase.country.752": "Швеция",
	"binBase.country.756": "Швейцария",
	"binBase.country.76": "Бразилия",
	"binBase.country.760": "Сирия",
	"binBase.country.762": "Таджикистан",
	"binBase.country.764": "Таиланд",
	"binBase.country.768": "Того",
	"binBase.country.772": "Токелау о-ва (NZ)",
	"binBase.country.776": "Тонга",
	"binBase.country.780": "Тринидад и Тобаго",
	"binBase.country.784": "Объединенные Арабские Эмираты",
	"binBase.country.788": "Тунис",
	"binBase.country.792": "Турция",
	"binBase.country.795": "Туркменистан",
	"binBase.country.796": "Теркс и Кайкос о-ва (GB)",
	"binBase.country.798": "Тувалу",
	"binBase.country.8": "Албания",
	"binBase.country.800": "Уганда",
	"binBase.country.804": "Украина",
	"binBase.country.807": "Македония",
	"binBase.country.818": "Египет",
	"binBase.country.826": "Великобритания",
	"binBase.country.831": "Гернси",
	"binBase.country.832": "Джерси",
	"binBase.country.833": "Остров Мэн",
	"binBase.country.834": "Танзания",
	"binBase.country.84": "Белиз",
	"binBase.country.840": "Соединенные Штаты Америки",
	"binBase.country.850": "Виргинские о-ва (US)",
	"binBase.country.854": "Буркина-Фасо",
	"binBase.country.858": "Уругвай",
	"binBase.country.86": "Британская территория Индийского океана (GB)",
	"binBase.country.860": "Узбекистан",
	"binBase.country.862": "Венесуэла",
	"binBase.country.876": "Уоллис и Футунао-ва (FR)",
	"binBase.country.882": "Самоа",
	"binBase.country.887": "Йемен",
	"binBase.country.891": "Югославия",
	"binBase.country.894": "Замбия",
	"binBase.country.90": "Соломоновы о-ва",
	"binBase.country.92": "Виргинские о-ва (GB)",
	"binBase.country.96": "Бруней Дарассалам",
	"binBase.country.999": "Республика Косово"
};


//////////////////
// WEBPACK FOOTER
// ./src/translation/ru.json
// module id = 665
// module chunks = 0